export default [
  {
    name: 'N·INT·1/99',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Propósito de la Normativa para la Infraestructura del Transporte',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 1999,
    url: 'https://normas.imt.mx/normativa/N-INT-1-99.pdf'
  },
  {
    name: 'N·INT·2/19',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2019,
    url: 'https://normas.imt.mx/normativa/N-INT-2-19.pdf'
  },
  {
    name: 'N·INT·2/18',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-INT-2-18.pdf'
  },
  {
    name: 'N·INT·2/17',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2017,
    url: 'https://normas.imt.mx/normativa/N-INT-2-17.pdf'
  },
  {
    name: 'N·INT·2/16',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-INT-2-16.pdf'
  },
  {
    name: 'N·INT·2/15',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-INT-2-15.pdf'
  },
  {
    name: 'N·INT·2/14',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-INT-2-14.pdf'
  },
  {
    name: 'N·INT·2/13',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-INT-2-13.pdf'
  },
  {
    name: 'N·INT·2/12',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2012,
    url: 'https://normas.imt.mx/normativa/N-INT-2-12.pdf'
  },
  {
    name: 'N·INT·2/11',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-INT-2-11.pdf'
  },
  {
    name: 'N·INT·2/10',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2010,
    url: 'https://normas.imt.mx/normativa/N-INT-2-10.pdf'
  },
  {
    name: 'N·INT·2/09',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2009,
    url: 'https://normas.imt.mx/normativa/N-INT-2-09.pdf'
  },
  {
    name: 'N·INT·2/08',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2008,
    url: 'https://normas.imt.mx/normativa/N-INT-2-08.pdf'
  },
  {
    name: 'N·INT·2/07',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-INT-2-07.pdf'
  },
  {
    name: 'N·INT·2/06',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-INT-2-06.pdf'
  },
  {
    name: 'N·INT·2/05',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-INT-2-05.pdf'
  },
  {
    name: 'N·INT·2/04',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-INT-2-04.pdf'
  },
  {
    name: 'N·INT·2/03',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-INT-2-03.pdf'
  },
  {
    name: 'N·INT·2/02',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-INT-2-02.pdf'
  },
  {
    name: 'N·INT·2/01',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-INT-2-01.pdf'
  },
  {
    name: 'N·INT·2/00',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Índice General',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-INT-2-00.pdf'
  },
  {
    name: 'N·INT·4/10',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Números, Unidades y Equivalencias',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2010,
    url: 'https://normas.imt.mx/normativa/N-INT-4-10.pdf'
  },
  {
    name: 'N·INT·4/00',
    type: 'Norma',
    book_id: 1,
    book_name: 'Introducción',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Números, Unidades y Equivalencias',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-INT-4-00.pdf'
  },
  {
    name: 'N·LEG·1/05',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Fundamentos para la Contratación y Ejecución de Obras Públicas y Servicios Relacionados con las Mismas',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-LEG-1-05.pdf'
  },
  {
    name: 'N·LEG·1/02',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Fundamentos para la Contratación y Ejecución de Obras Públicas y Servicios Relacionados con las Mismas',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-LEG-1-02.pdf'
  },
  {
    name: 'N·LEG·1/00',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Fundamentos para la Contratación y Ejecución de Obras Públicas y Servicios Relacionados con las Mismas',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-LEG-1-00.pdf'
  },
  {
    name: 'N·LEG·2/18',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Ejecución de Estudios, Proyectos, Consultorías y Asesorías. (Nombre anterior: Ejecución de Estudios, Proyectos y Consultorías)',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-LEG-2-18.pdf'
  },
  {
    name: 'N·LEG·2/07',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Ejecución de Estudios, Proyectos, Consultorías y Asesorías. (Nombre anterior: Ejecución de Estudios, Proyectos y Consultorías)',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-LEG-2-07.pdf'
  },
  {
    name: 'N·LEG·2/05',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Ejecución de Estudios, Proyectos, Consultorías y Asesorías. (Nombre anterior: Ejecución de Estudios, Proyectos y Consultorías)',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-LEG-2-05.pdf'
  },
  {
    name: 'N·LEG·2/02',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Ejecución de Estudios, Proyectos, Consultorías y Asesorías. (Nombre anterior: Ejecución de Estudios, Proyectos y Consultorías)',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-LEG-2-02.pdf'
  },
  {
    name: 'N·LEG·2/00',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Ejecución de Estudios, Proyectos, Consultorías y Asesorías. (Nombre anterior: Ejecución de Estudios, Proyectos y Consultorías)',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-LEG-2-00.pdf'
  },
  {
    name: 'N·LEG·3/18',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Ejecución de Obras',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-LEG-3-18.pdf'
  },
  {
    name: 'N·LEG·3/16',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Ejecución de Obras',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-LEG-3-16.pdf'
  },
  {
    name: 'N·LEG·3/07',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Ejecución de Obras',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-LEG-3-07.pdf'
  },
  {
    name: 'N·LEG·3/05',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Ejecución de Obras',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-LEG-3-05.pdf'
  },
  {
    name: 'N·LEG·3/02',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Ejecución de Obras',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-LEG-3-02.pdf'
  },
  {
    name: 'N·LEG·3/00',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Ejecución de Obras',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-LEG-3-00.pdf'
  },
  {
    name: 'N·LEG·4/18',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Ejecución de Supervisión de Obras',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-LEG-4-18.pdf'
  },
  {
    name: 'N·LEG·4/16',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Ejecución de Supervisión de Obras',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-LEG-4-16.pdf'
  },
  {
    name: 'N·LEG·4/07',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Ejecución de Supervisión de Obras',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-LEG-4-07.pdf'
  },
  {
    name: 'N·LEG·4/05',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Ejecución de Supervisión de Obras',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-LEG-4-05.pdf'
  },
  {
    name: 'N·LEG·4/02',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Ejecución de Supervisión de Obras',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-LEG-4-02.pdf'
  },
  {
    name: 'N·LEG·4/00',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Ejecución de Supervisión de Obras',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-LEG-4-00.pdf'
  },
  {
    name: 'N·LEG·5/07',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Ejecución de Obras por Adjudicación Directa',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-LEG-5-07.pdf'
  },
  {
    name: 'N·LEG·5/05',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Ejecución de Obras por Adjudicación Directa',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-LEG-5-05.pdf'
  },
  {
    name: 'N·LEG·5/02',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Ejecución de Obras por Adjudicación Directa',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-LEG-5-02.pdf'
  },
  {
    name: 'N·LEG·5/00',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Ejecución de Obras por Adjudicación Directa',
    title_id: null,
    title_name: null,
    chapter_id: null,
    chapter_name: null,
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-LEG-5-00.pdf'
  },
  {
    name: 'N·LEG·6·01/07',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 6,
    part_name: 'Contratación',
    title_id: '1',
    title_name: 'Contratación de Obras Públicas y de Servicios Relacionados con las Mismas',
    chapter_id: null,
    chapter_name: null,
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-LEG-6-01-07.pdf'
  },
  {
    name: 'N·LEG·6·01/05',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 6,
    part_name: 'Contratación',
    title_id: '1',
    title_name: 'Contratación de Obras Públicas y de Servicios Relacionados con las Mismas',
    chapter_id: null,
    chapter_name: null,
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-LEG-6-01-05.pdf'
  },
  {
    name: 'N·LEG·6·01/02',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 6,
    part_name: 'Contratación',
    title_id: '1',
    title_name: 'Contratación de Obras Públicas y de Servicios Relacionados con las Mismas',
    chapter_id: null,
    chapter_name: null,
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-LEG-6-01-02.pdf'
  },
  {
    name: 'N·LEG·6·01/00',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 6,
    part_name: 'Contratación',
    title_id: '1',
    title_name: 'Contratación de Obras Públicas y de Servicios Relacionados con las Mismas',
    chapter_id: null,
    chapter_name: null,
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-LEG-6-01-00.pdf'
  },
  {
    name: 'N·LEG·7·01/07',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 7,
    part_name: 'Concesiones',
    title_id: '1',
    title_name: 'Concesiones de Caminos y Puentes',
    chapter_id: null,
    chapter_name: null,
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-LEG-7-01-07.pdf'
  },
  {
    name: 'N·LEG·7·01/00',
    type: 'Norma',
    book_id: 2,
    book_name: 'Legislación',
    theme_id: null,
    theme_name: null,
    part_id: 7,
    part_name: 'Concesiones',
    title_id: '1',
    title_name: 'Concesiones de Caminos y Puentes',
    chapter_id: null,
    chapter_name: null,
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-LEG-7-01-00.pdf'
  },
  {
    name: 'N·PRY·CAR·1·01·001/07',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '1',
    title_name: 'Estudios Topográficos',
    chapter_id: '1',
    chapter_name: 'Ejecución de Estudios Topográficos y Aerofotogramétricos para Carreteras',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-01-001-07.pdf'
  },
  {
    name: 'N·PRY·CAR·1·01·002/07',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '1',
    title_name: 'Estudios Topográficos',
    chapter_id: '2',
    chapter_name: 'Trazo y Nivelación de Ejes para el Estudio Topográfico',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-01-002-07.pdf'
  },
  {
    name: 'N·PRY·CAR·1·01·003/07',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '1',
    title_name: 'Estudios Topográficos',
    chapter_id: '3',
    chapter_name: 'Levantamiento de las Secciones Transversales para el Estudio Topográfico',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-01-003-07.pdf'
  },
  {
    name: 'N·PRY·CAR·1·01·004/07',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '1',
    title_name: 'Estudios Topográficos',
    chapter_id: '4',
    chapter_name: 'Fotografías Aéreas para Estudios Aerofotogramétricos',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-01-004-07.pdf'
  },
  {
    name: 'N·PRY·CAR·1·01·005/07',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '1',
    title_name: 'Estudios Topográficos',
    chapter_id: '5',
    chapter_name: 'Restitución Aerofotogramétrica',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-01-005-07.pdf'
  },
  {
    name: 'N·PRY·CAR·1·01·006/07',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '1',
    title_name: 'Estudios Topográficos',
    chapter_id: '6',
    chapter_name: 'Presentación de Estudios Topográficos y Aerofotográmetricos para Carreteras',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-01-006-07.pdf'
  },
  {
    name: 'N·PRY·CAR·1·02·001/19',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '2',
    title_name: 'Estudios Geotécnicos',
    chapter_id: '1',
    chapter_name: 'Ejecución de Estudios Geotécnicos',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-02-001-19.pdf'
  },
  {
    name: 'N·PRY·CAR·1·02·003/19',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '2',
    title_name: 'Estudios Geotécnicos',
    chapter_id: '3',
    chapter_name: 'Exploración Directa del Subsuelo',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-02-003-19.pdf'
  },
  {
    name: 'N·PRY·CAR·1·02·004/19',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '2',
    title_name: 'Estudios Geotécnicos',
    chapter_id: '4',
    chapter_name: 'Exploración Indirecta del Subsuelo',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-02-004-19.pdf'
  },
  {
    name: 'N·PRY·CAR·1·02·005/19',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '2',
    title_name: 'Estudios Geotécnicos',
    chapter_id: '5',
    chapter_name: 'Prospección por Refracción Sísmica',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-02-005-19.pdf'
  },
  {
    name: 'N·PRY·CAR·1·03·001/00',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '3',
    title_name: 'Estudios Geológicos',
    chapter_id: '1',
    chapter_name: 'Ejecución de Estudios Geológicos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-03-001-00.pdf'
  },
  {
    name: 'N·PRY·CAR·1·03·002/00',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '3',
    title_name: 'Estudios Geológicos',
    chapter_id: '2',
    chapter_name: 'Fotogeología y Levantamientos Geológicos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-03-002-00.pdf'
  },
  {
    name: 'N·PRY·CAR·1·03·003/00',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '3',
    title_name: 'Estudios Geológicos',
    chapter_id: '3',
    chapter_name: 'Presentación del Estudio Geológico',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-03-003-00.pdf'
  },
  {
    name: 'N·PRY·CAR·1·06·001/18',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '6',
    title_name: 'Estudios Hidráulico-Hidrológicos para Puentes',
    chapter_id: '1',
    chapter_name: 'Ejecución de Estudios Hidráulico-Hidrológicos para Puentes',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-06-001-18.pdf'
  },
  {
    name: 'N·PRY·CAR·1·06·001/00',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '6',
    title_name: 'Estudios Hidráulico-Hidrológicos para Puentes',
    chapter_id: '1',
    chapter_name: 'Ejecución de Estudios Hidráulico-Hidrológicos para Puentes',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-06-001-00.pdf'
  },
  {
    name: 'N·PRY·CAR·1·06·002/18',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '6',
    title_name: 'Estudios Hidráulico-Hidrológicos para Puentes',
    chapter_id: '2',
    chapter_name: 'Trabajos de Campo',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-06-002-18.pdf'
  },
  {
    name: 'N·PRY·CAR·1·06·002/00',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '6',
    title_name: 'Estudios Hidráulico-Hidrológicos para Puentes',
    chapter_id: '2',
    chapter_name: 'Trabajos de Campo',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-06-002-00.pdf'
  },
  {
    name: 'N·PRY·CAR·1·06·003/18',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '6',
    title_name: 'Estudios Hidráulico-Hidrológicos para Puentes',
    chapter_id: '3',
    chapter_name: 'Procesamiento de Información',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-06-003-18.pdf'
  },
  {
    name: 'M·PRY·CAR·1·06·003/00',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '6',
    title_name: 'Estudios Hidráulico-Hidrológicos para Puentes',
    chapter_id: '3',
    chapter_name: 'Procesamiento de Información',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-PRY-CAR-1-06-003-00.pdf'
  },
  {
    name: 'N·PRY·CAR·1·06·003/00',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '6',
    title_name: 'Estudios Hidráulico-Hidrológicos para Puentes',
    chapter_id: '3',
    chapter_name: 'Procesamiento de Información',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-06-003-00.pdf'
  },
  {
    name: 'N·PRY·CAR·1·06·004/18',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '6',
    title_name: 'Estudios Hidráulico-Hidrológicos para Puentes',
    chapter_id: '4',
    chapter_name: 'Análisis Hidrológico',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-06-004-18.pdf'
  },
  {
    name: 'M·PRY·CAR·1·06·004/00',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '6',
    title_name: 'Estudios Hidráulico-Hidrológicos para Puentes',
    chapter_id: '4',
    chapter_name: 'Análisis Hidrológicos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-PRY-CAR-1-06-004-00.pdf'
  },
  {
    name: 'N·PRY·CAR·1·06·004/00',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '6',
    title_name: 'Estudios Hidráulico-Hidrológicos para Puentes',
    chapter_id: '4',
    chapter_name: 'Análisis Hidrológicos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-06-004-00.pdf'
  },
  {
    name: 'N·PRY·CAR·1·06·005/18',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '6',
    title_name: 'Estudios Hidráulico-Hidrológicos para Puentes',
    chapter_id: '5',
    chapter_name: 'Análisis Hidráulico',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-06-005-18.pdf'
  },
  {
    name: 'M·PRY·CAR·1·06·005/00',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '6',
    title_name: 'Estudios Hidráulico-Hidrológicos para Puentes',
    chapter_id: '5',
    chapter_name: 'Análisis Hidráulicos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-PRY-CAR-1-06-005-00.pdf'
  },
  {
    name: 'N·PRY·CAR·1·06·005/00',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '6',
    title_name: 'Estudios Hidráulico-Hidrológicos para Puentes',
    chapter_id: '5',
    chapter_name: 'Análisis Hidráulicos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-06-005-00.pdf'
  },
  {
    name: 'N·PRY·CAR·1·06·006/18',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '6',
    title_name: 'Estudios Hidráulico-Hidrológicos para Puentes',
    chapter_id: '6',
    chapter_name: 'Presentación del Estudio Hidráulico-Hidrológico para Puentes',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-06-006-18.pdf'
  },
  {
    name: 'N·PRY·CAR·1·06·006/00',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '6',
    title_name: 'Estudios Hidráulico-Hidrológicos para Puentes',
    chapter_id: '6',
    chapter_name: 'Presentación del Estudio Hidráulico-Hidrológico para Puentes',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-1-06-006-00.pdf'
  },
  {
    name: 'N·PRY·CAR·4·01·001/16',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Proyecto de Drenaje y Subdrenaje',
    title_id: '1',
    title_name: 'Proyectos de Obras Menores de Drenaje',
    chapter_id: '1',
    chapter_name: 'Ejecución del Proyecto de Obras Menores de Drenaje',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-4-01-001-16.pdf'
  },
  {
    name: 'N·PRY·CAR·4·01·002/16',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Proyecto de Drenaje y Subdrenaje',
    title_id: '1',
    title_name: 'Proyectos de Obras Menores de Drenaje',
    chapter_id: '2',
    chapter_name: 'Diseño Hidráulico de Obras Menores de Drenaje',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-4-01-002-16.pdf'
  },
  {
    name: 'M·PRY·CAR·4·01·002/16',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Proyecto de Drenaje y Subdrenaje',
    title_id: '1',
    title_name: 'Proyectos de Obras Menores de Drenaje',
    chapter_id: '2',
    chapter_name: 'Diseño Hidráulico de Obras Menores de Drenaje',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-PRY-CAR-4-01-002-16.pdf'
  },
  {
    name: 'N·PRY·CAR·4·01·003/16',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Proyecto de Drenaje y Subdrenaje',
    title_id: '1',
    title_name: 'Proyectos de Obras Menores de Drenaje',
    chapter_id: '3',
    chapter_name: 'Diseño Estructural de Obras Menores de Drenaje',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-4-01-003-16.pdf'
  },
  {
    name: 'M·PRY·CAR·4·01·003/16',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Proyecto de Drenaje y Subdrenaje',
    title_id: '1',
    title_name: 'Proyectos de Obras Menores de Drenaje',
    chapter_id: '3',
    chapter_name: 'Diseño Estructural de Obras Menores de Drenaje',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-PRY-CAR-4-01-003-16.pdf'
  },
  {
    name: 'N·PRY·CAR·4·01·004/16',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Proyecto de Drenaje y Subdrenaje',
    title_id: '1',
    title_name: 'Proyectos de Obras Menores de Drenaje',
    chapter_id: '4',
    chapter_name: 'Presentación del Proyecto de Obras Menores de Drenaje',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-4-01-004-16.pdf'
  },
  {
    name: 'N·PRY·CAR·4·02·001/16',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Proyecto de Drenaje y Subdrenaje',
    title_id: '2',
    title_name: 'Proyectos de Obras Complementarias de Drenaje',
    chapter_id: '1',
    chapter_name: 'Ejecución del Proyecto de Obras Complementarias de Drenaje',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-4-02-001-16.pdf'
  },
  {
    name: 'N·PRY·CAR·4·02·002/16',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Proyecto de Drenaje y Subdrenaje',
    title_id: '2',
    title_name: 'Proyectos de Obras Complementarias de Drenaje',
    chapter_id: '2',
    chapter_name: 'Diseño Hidráulico de Obras Complementarias de Drenaje',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-4-02-002-16.pdf'
  },
  {
    name: 'M·PRY·CAR·4·02·002/16',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Proyecto de Drenaje y Subdrenaje',
    title_id: '2',
    title_name: 'Proyectos de Obras Complementarias de Drenaje',
    chapter_id: '2',
    chapter_name: 'Diseño Hidráulico de Obras Complementarias de Drenaje',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-PRY-CAR-4-02-002-16.pdf'
  },
  {
    name: 'N·PRY·CAR·4·02·003/16',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Proyecto de Drenaje y Subdrenaje',
    title_id: '2',
    title_name: 'Proyectos de Obras Complementarias de Drenaje',
    chapter_id: '3',
    chapter_name: 'Diseño de Elementos que Constituyen las Obras Complementarias de Drenaje',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-4-02-003-16.pdf'
  },
  {
    name: 'N·PRY·CAR·4·02·004/16',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Proyecto de Drenaje y Subdrenaje',
    title_id: '2',
    title_name: 'Proyectos de Obras Complementarias de Drenaje',
    chapter_id: '4',
    chapter_name: 'Presentación del Proyecto de Obras Complementarias de Drenaje',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-4-02-004-16.pdf'
  },
  {
    name: 'N·PRY·CAR·4·03·010/19',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Proyecto de Drenaje y Subdrenaje',
    title_id: '3',
    title_name: 'Proyecto de Sistemas de Subdrenaje',
    chapter_id: '10',
    chapter_name: 'Presentación de Proyectos de Subdrenaje',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-4-03-010-19.pdf'
  },
  {
    name: 'N·PRY·CAR·6·01·001/01',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Proyecto de Puentes y Estructuras',
    title_id: '1',
    title_name: 'Proyecto de Nuevos Puentes y Estructuras Similares',
    chapter_id: '1',
    chapter_name: 'Ejecución de Proyectos de Nuevos Puentes y Estructuras Similares',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-6-01-001-01.pdf'
  },
  {
    name: 'N·PRY·CAR·6·01·002/01',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Proyecto de Puentes y Estructuras',
    title_id: '1',
    title_name: 'Proyecto de Nuevos Puentes y Estructuras Similares',
    chapter_id: '2',
    chapter_name: 'Características Generales de Proyecto',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-6-01-002-01.pdf'
  },
  {
    name: 'N·PRY·CAR·6·01·003/01',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Proyecto de Puentes y Estructuras',
    title_id: '1',
    title_name: 'Proyecto de Nuevos Puentes y Estructuras Similares',
    chapter_id: '3',
    chapter_name: 'Cargas y Acciones',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-6-01-003-01.pdf'
  },
  {
    name: 'N·PRY·CAR·6·01·004/01',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Proyecto de Puentes y Estructuras',
    title_id: '1',
    title_name: 'Proyecto de Nuevos Puentes y Estructuras Similares',
    chapter_id: '4',
    chapter_name: 'Viento',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-6-01-004-01.pdf'
  },
  {
    name: 'N·PRY·CAR·6·01·005/01',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Proyecto de Puentes y Estructuras',
    title_id: '1',
    title_name: 'Proyecto de Nuevos Puentes y Estructuras Similares',
    chapter_id: '5',
    chapter_name: 'Sismo',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-6-01-005-01.pdf'
  },
  {
    name: 'N·PRY·CAR·6·01·006/16',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Proyecto de Puentes y Estructuras',
    title_id: '1',
    title_name: 'Proyecto de Nuevos Puentes y Estructuras Similares',
    chapter_id: '6',
    chapter_name: 'Combinaciones de Carga',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-6-01-006-16.pdf'
  },
  {
    name: 'N·PRY·CAR·6·01·006/01',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Proyecto de Puentes y Estructuras',
    title_id: '1',
    title_name: 'Proyecto de Nuevos Puentes y Estructuras Similares',
    chapter_id: '6',
    chapter_name: 'Combinaciones de Cargas',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-6-01-006-01.pdf'
  },
  {
    name: 'N·PRY·CAR·6·01·007/16',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Proyecto de Puentes y Estructuras',
    title_id: '1',
    title_name: 'Proyecto de Nuevos Puentes y Estructuras Similares',
    chapter_id: '7',
    chapter_name: 'Distribución de Cargas',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-6-01-007-16.pdf'
  },
  {
    name: 'N·PRY·CAR·6·01·007/04',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Proyecto de Puentes y Estructuras',
    title_id: '1',
    title_name: 'Proyecto de Nuevos Puentes y Estructuras Similares',
    chapter_id: '7',
    chapter_name: 'Distribución de Cargas',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-6-01-007-04.pdf'
  },
  {
    name: 'M·PRY·CAR·6·01·008/04',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Proyecto de Puentes y Estructuras',
    title_id: '1',
    title_name: 'Proyecto de Nuevos Puentes y Estructuras Similares',
    chapter_id: '8',
    chapter_name: 'Consideraciones para Puentes Especiales',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/M-PRY-CAR-6-01-008-04.pdf'
  },
  {
    name: 'N·PRY·CAR·6·01·009/04',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Proyecto de Puentes y Estructuras',
    title_id: '1',
    title_name: 'Proyecto de Nuevos Puentes y Estructuras Similares',
    chapter_id: '9',
    chapter_name: 'Presentación del Proyecto de Nuevos Puentes y Estructuras Similares',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-6-01-009-04.pdf'
  },
  {
    name: 'N·PRY·CAR·8·01·001/18',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 8,
    part_name: 'Proyecto de Cimentaciones',
    title_id: '1',
    title_name: 'Cimentaciones Superficiales',
    chapter_id: '1',
    chapter_name: 'Ejecución de Proyectos de Cimentaciones Superficiales',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-8-01-001-18.pdf'
  },
  {
    name: 'N·PRY·CAR·8·01·002/19',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 8,
    part_name: 'Proyecto de Cimentaciones',
    title_id: '1',
    title_name: 'Cimentaciones Superficiales',
    chapter_id: '2',
    chapter_name: 'Selección del Tipo de Cimentaciones Superficial y Dimensionamiento Preliminar',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-8-01-002-19.pdf'
  },
  {
    name: 'N·PRY·CAR·8·01·003/18',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 8,
    part_name: 'Proyecto de Cimentaciones',
    title_id: '1',
    title_name: 'Cimentaciones Superficiales',
    chapter_id: '3',
    chapter_name: 'Determinación de la Capacidad de Carga del Subsuelo o Roca y Revisión del Estado Límite de Falla de Cimentaciones Superficiales',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-8-01-003-18.pdf'
  },
  {
    name: 'N·PRY·CAR·8·01·004/19',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 8,
    part_name: 'Proyecto de Cimentaciones',
    title_id: '1',
    title_name: 'Cimentaciones Superficiales',
    chapter_id: '4',
    chapter_name: 'Revisión del Estado Límite de Servicio de Cimentaciones Superficiales',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-8-01-004-19.pdf'
  },
  {
    name: 'N·PRY·CAR·8·01·006/19',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 8,
    part_name: 'Proyecto de Cimentaciones',
    title_id: '1',
    title_name: 'Cimentaciones Superficiales',
    chapter_id: '6',
    chapter_name: 'Presentación del Proyecto de Cimentaciones Superficiales',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-8-01-006-19.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·001/13',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '1',
    chapter_name: 'Ejecución de Proyectos de Señalamiento',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-001-13.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·001/99',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '1',
    chapter_name: 'Ejecución de Proyectos de Señalamiento',
    year: 1999,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-001-99.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·002/13',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '2',
    chapter_name: 'Diseño de Señalamiento Horizontal',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-002-13.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·002/05',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '2',
    chapter_name: 'Diseño de Señalamiento Horizontal',
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-002-05.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·002/99',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '2',
    chapter_name: 'Diseño de Señalamiento Horizontal',
    year: 1999,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-002-99.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·003/13',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '3',
    chapter_name: 'Diseño de Señales Preventivas',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-003-13.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·003/99',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '3',
    chapter_name: 'Diseño de Señales Preventivas',
    year: 1999,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-003-99.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·004/13',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '4',
    chapter_name: 'Diseño de Señales Restrictivas',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-004-13.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·004/99',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '4',
    chapter_name: 'Diseño de Señales Restrictivas',
    year: 1999,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-004-99.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·005/13',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '5',
    chapter_name: 'Diseño de Señales Informativas',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-005-13.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·005/99',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '5',
    chapter_name: 'Diseño de Señales Informativas',
    year: 1999,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-005-99.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·006/13',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '6',
    chapter_name: 'Diseño de Señales Turísticas y de Servicios',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-006-13.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·006/99',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '6',
    chapter_name: 'Diseño de Señales Turísticas y de Servicios',
    year: 1999,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-006-99.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·007/13',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '7',
    chapter_name: 'Diseño de Señales Diversas',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-007-13.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·007/99',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '7',
    chapter_name: 'Diseño de Señales Diversas',
    year: 1999,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-007-99.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·008/13',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '8',
    chapter_name: 'Diseño de Estructuras de Soporte para Señales Verticales',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-008-13.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·008/99',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '8',
    chapter_name: 'Diseño de Estructuras de Soporte para Señales Verticales',
    year: 1999,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-008-99.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·009/13',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '9',
    chapter_name: 'Presentación del Proyecto de Señalamiento',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-009-13.pdf'
  },
  {
    name: 'N·PRY·CAR·10·01·009/99',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '1',
    title_name: 'Proyecto de Señalamiento',
    chapter_id: '9',
    chapter_name: 'Presentación del Proyecto de Señalamiento',
    year: 1999,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-01-009-99.pdf'
  },
  {
    name: 'N·PRY·CAR·10·03·001/01',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '3',
    title_name: 'Proyecto de Señalamiento y Dispositivos para Protección en Obras',
    chapter_id: '1',
    chapter_name: 'Ejecución de Proyecto de Señalamiento y Dispositivos para Protección en Obras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-03-001-01.pdf'
  },
  {
    name: 'N·PRY·CAR·10·03·002/01',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '3',
    title_name: 'Proyecto de Señalamiento y Dispositivos para Protección en Obras',
    chapter_id: '2',
    chapter_name: 'Señalamiento Vertical para Protección en Obras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-03-002-01.pdf'
  },
  {
    name: 'N·PRY·CAR·10·03·003/01',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '3',
    title_name: 'Proyecto de Señalamiento y Dispositivos para Protección en Obras',
    chapter_id: '3',
    chapter_name: 'Dispositivos de Canalización para Protección en Obras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-03-003-01.pdf'
  },
  {
    name: 'N·PRY·CAR·10·03·004/01',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '3',
    title_name: 'Proyecto de Señalamiento y Dispositivos para Protección en Obras',
    chapter_id: '4',
    chapter_name: 'Presentación del Proyecto de Señalamiento para Protección en Obras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-03-004-01.pdf'
  },
  {
    name: 'N·PRY·CAR·10·04·001/05',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '4',
    title_name: 'Proyecto de Dispositivos de Seguridad',
    chapter_id: '1',
    chapter_name: 'Ejecución de Proyectos de Dispositivos de Seguridad',
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-04-001-05.pdf'
  },
  {
    name: 'N·PRY·CAR·10·04·006/08',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '4',
    title_name: 'Proyecto de Dispositivos de Seguridad',
    chapter_id: '6',
    chapter_name: 'Dispositivos para Control de la Velocidad y Alertadores de Salida del Camino. (Nombre anterior: Dispositivos para Control de la Velocidad)',
    year: 2008,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-04-006-08.pdf'
  },
  {
    name: 'N·PRY·CAR·10·04·006/05',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '4',
    title_name: 'Proyecto de Dispositivos de Seguridad',
    chapter_id: '6',
    chapter_name: 'Dispositivos para Control de la Velocidad y Alertadores de Salida del Camino. (Nombre anterior: Dispositivos para Control de la Velocidad)',
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-04-006-05.pdf'
  },
  {
    name: 'N·PRY·CAR·10·04·007/13',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '4',
    title_name: 'Proyecto de Dispositivos de Seguridad',
    chapter_id: '7',
    chapter_name: 'Rampas para Frenado de Emergencia',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-04-007-13.pdf'
  },
  {
    name: 'N·PRY·CAR·10·04·007/07',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '4',
    title_name: 'Proyecto de Dispositivos de Seguridad',
    chapter_id: '7',
    chapter_name: 'Rampas para Frenado de Emergencia',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-04-007-07.pdf'
  },
  {
    name: 'N·PRY·CAR·10·06·001/14',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '6',
    title_name: 'Iluminación',
    chapter_id: '1',
    chapter_name: 'Ejecución de Proyectos de Iluminación para Carreteras y Vialidades Urbanas',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-06-001-14.pdf'
  },
  {
    name: 'N·PRY·CAR·10·06·002/14',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '6',
    title_name: 'Iluminación',
    chapter_id: '2',
    chapter_name: 'Criterios Generales para el Diseño de Iluminación',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-06-002-14.pdf'
  },
  {
    name: 'N·PRY·CAR·10·06·003/14',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '6',
    title_name: 'Iluminación',
    chapter_id: '3',
    chapter_name: 'Iluminación de Túneles',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-06-003-14.pdf'
  },
  {
    name: 'N·PRY·CAR·10·06·004/14',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '6',
    title_name: 'Iluminación',
    chapter_id: '4',
    chapter_name: 'Iluminación de Carreteras',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-06-004-14.pdf'
  },
  {
    name: 'N·PRY·CAR·10·06·007/16',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 10,
    part_name: 'Proyecto de Señalamiento y Dispositivos de Seguridad en Carreteras y Vialidades Urbanas',
    title_id: '6',
    title_name: 'Iluminación',
    chapter_id: '7',
    chapter_name: 'Presentación del Proyecto de Ilumiación',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-PRY-CAR-10-06-007-16.pdf'
  },
  {
    name: 'N·PRY·PUE·1·04·001/08',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '4',
    title_name: 'Estudios de Mareas',
    chapter_id: '1',
    chapter_name: 'Ejecución de Estudios de Mareas',
    year: 2008,
    url: 'https://normas.imt.mx/normativa/N-PRY-PUE-1-04-001-08.pdf'
  },
  {
    name: 'M·PRY·PUE·1·04·002/08',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '4',
    title_name: 'Estudios de Mareas',
    chapter_id: '2',
    chapter_name: 'Recopilación y Análisis de Información',
    year: 2008,
    url: 'https://normas.imt.mx/normativa/M-PRY-PUE-1-04-002-08.pdf'
  },
  {
    name: 'M·PRY·PUE·1·04·003/08',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '4',
    title_name: 'Estudios de Mareas',
    chapter_id: '3',
    chapter_name: 'Medición de Niveles del Mar',
    year: 2008,
    url: 'https://normas.imt.mx/normativa/M-PRY-PUE-1-04-003-08.pdf'
  },
  {
    name: 'M·PRY·PUE·1·04·004/08',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '4',
    title_name: 'Estudios de Mareas',
    chapter_id: '4',
    chapter_name: 'Predicción de la Marea Astronómica',
    year: 2008,
    url: 'https://normas.imt.mx/normativa/M-PRY-PUE-1-04-004-08.pdf'
  },
  {
    name: 'M·PRY·PUE·1·04·005/09',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '4',
    title_name: 'Estudios de Mareas',
    chapter_id: '5',
    chapter_name: 'Predicción de la Marea Meteorológica',
    year: 2009,
    url: 'https://normas.imt.mx/normativa/M-PRY-PUE-1-04-005-09.pdf'
  },
  {
    name: 'M·PRY·PUE·1·04·005/08',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '4',
    title_name: 'Estudios de Mareas',
    chapter_id: '5',
    chapter_name: 'Predicción de la Marea Meteorológica',
    year: 2008,
    url: 'https://normas.imt.mx/normativa/M-PRY-PUE-1-04-005-08.pdf'
  },
  {
    name: 'N·PRY·PUE·1·04·006/08',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '4',
    title_name: 'Estudios de Mareas',
    chapter_id: '6',
    chapter_name: 'Presentación de Estudios de Mareas',
    year: 2008,
    url: 'https://normas.imt.mx/normativa/N-PRY-PUE-1-04-006-08.pdf'
  },
  {
    name: 'N·PRY·PUE·1·07·001/06',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '7',
    title_name: 'Estudios de Transporte Litoral',
    chapter_id: '1',
    chapter_name: 'Ejecución de Estudios de Transporte Litoral',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-PRY-PUE-1-07-001-06.pdf'
  },
  {
    name: 'M·PRY·PUE·1·07·002/06',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '7',
    title_name: 'Estudios de Transporte Litoral',
    chapter_id: '2',
    chapter_name: 'Reconocimiento de Zonas Costeras',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/M-PRY-PUE-1-07-002-06.pdf'
  },
  {
    name: 'M·PRY·PUE·1·07·003/06',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '7',
    title_name: 'Estudios de Transporte Litoral',
    chapter_id: '3',
    chapter_name: 'Caracterización Mineralógica y Granulométrica de los Sedimentos',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/M-PRY-PUE-1-07-003-06.pdf'
  },
  {
    name: 'M·PRY·PUE·1·07·004/06',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '7',
    title_name: 'Estudios de Transporte Litoral',
    chapter_id: '4',
    chapter_name: 'Cuantificación del Transporte Litoral',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/M-PRY-PUE-1-07-004-06.pdf'
  },
  {
    name: 'M·PRY·PUE·1·07·005/06',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '7',
    title_name: 'Estudios de Transporte Litoral',
    chapter_id: '5',
    chapter_name: 'Determinación del Estado Morfódinámico de las Playas',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/M-PRY-PUE-1-07-005-06.pdf'
  },
  {
    name: 'M·PRY·PUE·1·07·006/06',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '7',
    title_name: 'Estudios de Transporte Litoral',
    chapter_id: '6',
    chapter_name: 'Determinación del Perfil de Equilibrio',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/M-PRY-PUE-1-07-006-06.pdf'
  },
  {
    name: 'M·PRY·PUE·1·07·007/06',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '7',
    title_name: 'Estudios de Transporte Litoral',
    chapter_id: '7',
    chapter_name: 'Determinación de los Cambios en la Línea de Costa',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/M-PRY-PUE-1-07-007-06.pdf'
  },
  {
    name: 'M·PRY·PUE·1·07·008/06',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '7',
    title_name: 'Estudios de Transporte Litoral',
    chapter_id: '8',
    chapter_name: 'Determinación en Campo de la Tasa de Transporte Litoral mediante Trazadores Fluorescentes',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/M-PRY-PUE-1-07-008-06.pdf'
  },
  {
    name: 'M·PRY·PUE·1·07·009/07',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '7',
    title_name: 'Estudios de Transporte Litoral',
    chapter_id: '9',
    chapter_name: 'Estimación del Relleno de Playas para Modificar su Perfil',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/M-PRY-PUE-1-07-009-07.pdf'
  },
  {
    name: 'M·PRY·PUE·1·07·010/07',
    type: 'Manual',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '7',
    title_name: 'Estudios de Transporte Litoral',
    chapter_id: '10',
    chapter_name: 'Determinación del Porcentaje de Sedimentación en los Canales de Acceso',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/M-PRY-PUE-1-07-010-07.pdf'
  },
  {
    name: 'N·PRY·PUE·1·07·011/07',
    type: 'Norma',
    book_id: 5,
    book_name: 'Proyecto',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Estudios',
    title_id: '7',
    title_name: 'Estudios de Transporte Litoral',
    chapter_id: '11',
    chapter_name: 'Presentación de Estudios de Transporte Litoral',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-PRY-PUE-1-07-011-07.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·001/11',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '1',
    chapter_name: 'Desmonte',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-001-11.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·001/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '1',
    chapter_name: 'Desmonte',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-001-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·002/11',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '2',
    chapter_name: 'Despalme',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-002-11.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·002/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '2',
    chapter_name: 'Despalme',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-002-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·003/11',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '3',
    chapter_name: 'Cortes',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-003-11.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·003/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '3',
    chapter_name: 'Cortes',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-003-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·004/11',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '4',
    chapter_name: 'Escalones de Liga',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-004-11.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·004/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '4',
    chapter_name: 'Escalones de Liga',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-004-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·005/11',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '5',
    chapter_name: 'Excavación para Canales',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-005-11.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·005/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '5',
    chapter_name: 'Excavación para Canales',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-005-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·006/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '6',
    chapter_name: 'Afinamiento',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-006-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·007/11',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '7',
    chapter_name: 'Excavación para Estructuras',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-007-11.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·007/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '7',
    chapter_name: 'Excavación para Estructuras',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-007-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·008/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '8',
    chapter_name: 'Bancos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-008-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·009/16',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '9',
    chapter_name: 'Terraplenes',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-009-16.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·009/11',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '9',
    chapter_name: 'Terraplenes',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-009-11.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·009/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '9',
    chapter_name: 'Terraplenes',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-009-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·010/11',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '10',
    chapter_name: 'Terraplenes Reforzados',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-010-11.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·010/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '10',
    chapter_name: 'Terraplenes Reforzados',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-010-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·011/11',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '11',
    chapter_name: 'Rellenos',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-011-11.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·011/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '11',
    chapter_name: 'Rellenos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-011-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·012/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '12',
    chapter_name: 'Recubrimiento de Taludes',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-012-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·013/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '13',
    chapter_name: 'Acarreos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-013-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·014/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '14',
    chapter_name: 'Abatimiento de Taludes',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-014-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·015/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '15',
    chapter_name: 'Bermas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-015-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·016/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '16',
    chapter_name: 'Anclas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-016-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·01·017/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '17',
    chapter_name: 'Concreto Lanzado',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-01-017-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·02·001/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Estructuras',
    chapter_id: '1',
    chapter_name: 'Mampostería de Piedra',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-02-001-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·02·002/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Estructuras',
    chapter_id: '2',
    chapter_name: 'Zampeado',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-02-002-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·02·003/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Estructuras',
    chapter_id: '3',
    chapter_name: 'Concreto Hidráulico',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-02-003-04.pdf'
  },
  {
    name: 'N·CTR·CAR·1·02·003/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Estructuras',
    chapter_id: '3',
    chapter_name: 'Concreto Hidráulico',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-02-003-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·02·004/02',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Estructuras',
    chapter_id: '4',
    chapter_name: 'Acero para Concreto Hidráulico',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-02-004-02.pdf'
  },
  {
    name: 'N·CTR·CAR·1·02·004/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Estructuras',
    chapter_id: '4',
    chapter_name: 'Acero para Concreto Hidráulico',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-02-004-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·02·005/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Estructuras',
    chapter_id: '5',
    chapter_name: 'Acero Estructural y Elementos Metálicos',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-02-005-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·02·006/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Estructuras',
    chapter_id: '6',
    chapter_name: 'Estructuras de Concreto Reforzado',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-02-006-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·02·007/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Estructuras',
    chapter_id: '7',
    chapter_name: 'Estructuras de Concreto Presforzado',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-02-007-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·02·008/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Estructuras',
    chapter_id: '8',
    chapter_name: 'Estructuras de Acero',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-02-008-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·02·009/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Estructuras',
    chapter_id: '9',
    chapter_name: 'Parapetos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-02-009-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·02·010/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Estructuras',
    chapter_id: '10',
    chapter_name: 'Guarniciones y Banquetas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-02-010-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·02·011/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Estructuras',
    chapter_id: '11',
    chapter_name: 'Preservación de Madera',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-02-011-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·02·012/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Estructuras',
    chapter_id: '12',
    chapter_name: 'Recubrimiento con Pintura',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-02-012-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·02·013/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Estructuras',
    chapter_id: '13',
    chapter_name: 'Demoliciones y Desmantelamientos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-02-013-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·03·001/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '3',
    title_name: 'Drenaje y Subdrenaje',
    chapter_id: '1',
    chapter_name: 'Alcantarillas de Lámina Corrugada de Acero',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-03-001-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·03·002/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '3',
    title_name: 'Drenaje y Subdrenaje',
    chapter_id: '2',
    chapter_name: 'Alcantarillas Tubulares de Concreto',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-03-002-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·03·003/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '3',
    title_name: 'Drenaje y Subdrenaje',
    chapter_id: '3',
    chapter_name: 'Cunetas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-03-003-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·03·004/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '3',
    title_name: 'Drenaje y Subdrenaje',
    chapter_id: '4',
    chapter_name: 'Contracunetas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-03-004-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·03·005/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '3',
    title_name: 'Drenaje y Subdrenaje',
    chapter_id: '5',
    chapter_name: 'Revestimiento de Canales',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-03-005-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·03·006/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '3',
    title_name: 'Drenaje y Subdrenaje',
    chapter_id: '6',
    chapter_name: 'Lavaderos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-03-006-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·03·007/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '3',
    title_name: 'Drenaje y Subdrenaje',
    chapter_id: '7',
    chapter_name: 'Bordillos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-03-007-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·03·008/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '3',
    title_name: 'Drenaje y Subdrenaje',
    chapter_id: '8',
    chapter_name: 'Vados',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-03-008-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·03·009/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '3',
    title_name: 'Drenaje y Subdrenaje',
    chapter_id: '9',
    chapter_name: 'Subdrenes',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-03-009-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·03·010/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '3',
    title_name: 'Drenaje y Subdrenaje',
    chapter_id: '10',
    chapter_name: 'Geodrenes',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-03-010-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·03·011/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '3',
    title_name: 'Drenaje y Subdrenaje',
    chapter_id: '11',
    chapter_name: 'Capas Drenantes',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-03-011-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·03·012/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '3',
    title_name: 'Drenaje y Subdrenaje',
    chapter_id: '12',
    chapter_name: 'Drenes de Penetración Transversal',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-03-012-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·03·013/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '3',
    title_name: 'Drenaje y Subdrenaje',
    chapter_id: '13',
    chapter_name: 'Trincheras Estabilizadoras',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-03-013-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·03·014/09',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '3',
    title_name: 'Drenaje y Subdrenaje',
    chapter_id: '14',
    chapter_name: 'Alcantarillas de Tubos Corrugados de Polietileno de Alta Densidad',
    year: 2009,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-03-014-09.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·001/03',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '1',
    chapter_name: 'Revestimientos Estabilizados y no Estabilizados. (Nombre anterior: Revestimientos)',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-001-03.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·001/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '1',
    chapter_name: 'Revestimientos Estabilizados y no Estabilizados. (Nombre anterior: Revestimientos)',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-001-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·002/11',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '2',
    chapter_name: 'Subbases y Bases',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-002-11.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·002/03',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '2',
    chapter_name: 'Subbases y Bases',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-002-03.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·002/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '2',
    chapter_name: 'Subbases y Bases',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-002-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·003/14',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '3',
    chapter_name: 'Capas Estabilizadas',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-003-14.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·003/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '3',
    chapter_name: 'Capas Estabilizadas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-003-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·004/15',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '4',
    chapter_name: 'Riegos de Impregnación',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-004-15.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·004/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '4',
    chapter_name: 'Riegos de Impregnación',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-004-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·005/15',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '5',
    chapter_name: 'Riegos de Liga',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-005-15.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·005/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '5',
    chapter_name: 'Riegos de Liga',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-005-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·006/14',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '6',
    chapter_name: 'Carpetas Asfálticas con Mezcla en Caliente',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-006-14.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·006/09',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '6',
    chapter_name: 'Carpetas Asfálticas con Mezcla en Caliente',
    year: 2009,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-006-09.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·006/08',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '6',
    chapter_name: 'Carpetas Asfálticas con Mezcla en Caliente',
    year: 2008,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-006-08.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·006/06',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '6',
    chapter_name: 'Carpetas Asfálticas con Mezcla en Caliente',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-006-06.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·006/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '6',
    chapter_name: 'Carpetas Asfálticas con Mezcla en Caliente',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-006-04.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·006/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '6',
    chapter_name: 'Carpetas Asfálticas con Mezcla en Caliente',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-006-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·006/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '6',
    chapter_name: 'Carpetas Asfálticas con Mezcla en Caliente',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-006-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·007/15',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '7',
    chapter_name: 'Carpetas Asfálticas con Mezcla en Frío',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-007-15.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·007/09',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '7',
    chapter_name: 'Carpetas Asfálticas con Mezcla en Frío',
    year: 2009,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-007-09.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·007/06',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '7',
    chapter_name: 'Carpetas Asfálticas con Mezcla en Frío',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-007-06.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·007/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '7',
    chapter_name: 'Carpetas Asfálticas con Mezcla en Frío',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-007-04.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·007/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '7',
    chapter_name: 'Carpetas Asfálticas con Mezcla en Frío',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-007-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·007/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '7',
    chapter_name: 'Carpetas Asfálticas con Mezcla en Frío',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-007-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·008/13',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '8',
    chapter_name: 'Capas de Rodadura con Mezcla Asfáltica en Frío',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-008-13.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·008/09',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '8',
    chapter_name: 'Capas de Rodadura con Mezcla Asfáltica en Frío. (Nombre anterior: Carpetas por el Sistema de Riegos)',
    year: 2009,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-008-09.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·008/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '8',
    chapter_name: 'Capas de Rodadura con Mezcla Asfáltica en Frío. (Nombre anterior: Carpetas por el Sistema de Riegos)',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-008-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·009/06',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '9',
    chapter_name: 'Carpetas de Concreto Hidráulico',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-009-06.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·009/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '9',
    chapter_name: 'Carpetas de Concreto Hidráulico',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-009-04.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·009/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '9',
    chapter_name: 'Carpetas de Concreto Hidráulico',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-009-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·009/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '9',
    chapter_name: 'Carpetas de Concreto Hidráulico',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-009-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·04·010/09',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '4',
    title_name: 'Pavimentos',
    chapter_id: '10',
    chapter_name: 'Capas de Rodadura con Mezcla Asfáltica en Caliente',
    year: 2009,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-04-010-09.pdf'
  },
  {
    name: 'N·CTR·CAR·1·05·001/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '5',
    title_name: 'Túneles',
    chapter_id: '1',
    chapter_name: 'Excavación de Túneles con Explosivos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-05-001-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·05·002/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '5',
    title_name: 'Túneles',
    chapter_id: '2',
    chapter_name: 'Excavación de Túneles con Máquinas Perforadoras de Frente Pleno en Roca',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-05-002-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·05·003/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '5',
    title_name: 'Túneles',
    chapter_id: '3',
    chapter_name: 'Excavación de Túneles con Escudo en Suelos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-05-003-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·05·004/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '5',
    title_name: 'Túneles',
    chapter_id: '4',
    chapter_name: 'Anclas para Soporte de Túneles',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-05-004-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·05·005/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '5',
    title_name: 'Túneles',
    chapter_id: '5',
    chapter_name: 'Malla Electrosoldada en Túneles',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-05-005-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·05·006/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '5',
    title_name: 'Túneles',
    chapter_id: '6',
    chapter_name: 'Concreto Lanzado en Túneles',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-05-006-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·05·007/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '5',
    title_name: 'Túneles',
    chapter_id: '7',
    chapter_name: 'Marcos Metálicos en Túneles',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-05-007-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·05·008/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '5',
    title_name: 'Túneles',
    chapter_id: '8',
    chapter_name: 'Revestimiento de Túneles',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-05-008-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·05·009/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '5',
    title_name: 'Túneles',
    chapter_id: '9',
    chapter_name: 'Inyecciones en Túneles',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-05-009-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·06·001/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '6',
    title_name: 'Cimentaciones',
    chapter_id: '1',
    chapter_name: 'Pilotes de Madera',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-06-001-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·06·002/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '6',
    title_name: 'Cimentaciones',
    chapter_id: '2',
    chapter_name: 'Pilotes Precolados',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-06-002-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·06·003/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '6',
    title_name: 'Cimentaciones',
    chapter_id: '3',
    chapter_name: 'Pilotes Colados en el Lugar',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-06-003-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·06·004/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '6',
    title_name: 'Cimentaciones',
    chapter_id: '4',
    chapter_name: 'Pilotes de Acero',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-06-004-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·06·005/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '6',
    title_name: 'Cimentaciones',
    chapter_id: '5',
    chapter_name: 'Cilindros y Cajones de Cimentación',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-06-005-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·06·006/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '6',
    title_name: 'Cimentaciones',
    chapter_id: '6',
    chapter_name: 'Tablaestacados',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-06-006-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·001/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '1',
    chapter_name: 'Marcas en el Pavimento',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-001-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·002/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '2',
    chapter_name: 'Marcas en Guarniciones',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-002-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·003/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '3',
    chapter_name: 'Marcas en Estructuras y Objetos Adyacentes a la Superficie de Rodamiento',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-003-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·004/02',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '4',
    chapter_name: 'Vialetas y Botones',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-004-02.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·004/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '4',
    chapter_name: 'Vialetas y Botones',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-004-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·005/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '5',
    chapter_name: 'Señales Verticales Bajas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-005-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·006/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '6',
    chapter_name: 'Señales Verticales Elevadas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-006-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·007/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '7',
    chapter_name: 'Indicadores de Alineamiento',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-007-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·008/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '8',
    chapter_name: 'Reglas y Tubos Guía para Vados',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-008-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·009/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '9',
    chapter_name: 'Defensas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-009-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·010/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '10',
    chapter_name: 'Barreras Centrales',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-010-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·011/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '11',
    chapter_name: 'Bordos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-011-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·012/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '12',
    chapter_name: 'Vibradores',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-012-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·013/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '13',
    chapter_name: 'Guardaganados',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-013-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·014/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '14',
    chapter_name: 'Barreras',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-014-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·015/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '15',
    chapter_name: 'Cercas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-015-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·07·016/00',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '7',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '16',
    chapter_name: 'Señalamiento y Dispositivos para Protección en Obras',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-07-016-00.pdf'
  },
  {
    name: 'N·CTR·CAR·1·08·001/07',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '8',
    title_name: 'Obras Marginales',
    chapter_id: '1',
    chapter_name: 'Poliductos para Fibra Óptica en el Acotamiento de Carreteras',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-08-001-07.pdf'
  },
  {
    name: 'N·CTR·CAR·1·08·001/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '8',
    title_name: 'Obras Marginales',
    chapter_id: '1',
    chapter_name: 'Poliductos para Fibra Óptica en el Acotamiento de Carreteras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-08-001-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·08·002/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '8',
    title_name: 'Obras Marginales',
    chapter_id: '2',
    chapter_name: 'Registros para Fibra Óptica en el Acotamiento de Carreteras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-08-002-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·08·003/07',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '8',
    title_name: 'Obras Marginales',
    chapter_id: '3',
    chapter_name: 'Poliductos para Fibra Óptica en la Calzada de Carreteras',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-08-003-07.pdf'
  },
  {
    name: 'N·CTR·CAR·1·08·003/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '8',
    title_name: 'Obras Marginales',
    chapter_id: '3',
    chapter_name: 'Poliductos para Fibra Óptica en la Calzada de Carreteras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-08-003-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·08·004/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '8',
    title_name: 'Obras Marginales',
    chapter_id: '4',
    chapter_name: 'Registros para Fibra Óptica en la Calzada de Carreteras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-08-004-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·08·005/07',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '8',
    title_name: 'Obras Marginales',
    chapter_id: '5',
    chapter_name: 'Poliductos para Fibra Óptica en Caminos Rurales',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-08-005-07.pdf'
  },
  {
    name: 'N·CTR·CAR·1·08·005/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '8',
    title_name: 'Obras Marginales',
    chapter_id: '5',
    chapter_name: 'Poliductos para Fibra Óptica en Caminos Rurales',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-08-005-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·08·006/01',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '8',
    title_name: 'Obras Marginales',
    chapter_id: '6',
    chapter_name: 'Registros para Fibra Óptica en Caminos Rurales',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-08-006-01.pdf'
  },
  {
    name: 'N·CTR·CAR·1·08·007/19',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '8',
    title_name: 'Obras Marginales',
    chapter_id: '7',
    chapter_name: 'Tritubos para Fibra Óptica en el Acotamiento de Carreteras Nuevas con Pavimento Asfáltico',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-08-007-19.pdf'
  },
  {
    name: 'N·CTR·CAR·1·08·007/13',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '8',
    title_name: 'Obras Marginales',
    chapter_id: '7',
    chapter_name: 'Tritubos para Fibra Óptica en el Acotamiento de Carreteras Nuevas',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-08-007-13.pdf'
  },
  {
    name: 'N·CTR·CAR·1·08·007/11',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '8',
    title_name: 'Obras Marginales',
    chapter_id: '7',
    chapter_name: 'Tritubos para Fibra Óptica en el Acotamiento de Carreteras Nuevas',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-08-007-11.pdf'
  },
  {
    name: 'N·CTR·CAR·1·08·008/11',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '8',
    title_name: 'Obras Marginales',
    chapter_id: '8',
    chapter_name: 'Registros para Tritubos para Fibra Óptica en Carreteras Nuevas',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-08-008-11.pdf'
  },
  {
    name: 'N·CTR·CAR·1·11·001/13',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '11',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '1',
    chapter_name: 'Señales Verticales Elevadas de Mensaje Cambiable',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-11-001-13.pdf'
  },
  {
    name: 'N·CTR·CAR·1·11·003/14',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '11',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '3',
    chapter_name: 'Cámaras de Video',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-CTR-CAR-1-11-003-14.pdf'
  },
  {
    name: 'N·CTR·PUE·1·01·001/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '1',
    chapter_name: 'Desmonte',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-01-001-04.pdf'
  },
  {
    name: 'N·CTR·PUE·1·01·002/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '2',
    chapter_name: 'Despalme',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-01-002-04.pdf'
  },
  {
    name: 'N·CTR·PUE·1·01·003/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '3',
    chapter_name: 'Cortes',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-01-003-04.pdf'
  },
  {
    name: 'N·CTR·PUE·1·01·004/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '4',
    chapter_name: 'Escalones de Liga',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-01-004-04.pdf'
  },
  {
    name: 'N·CTR·PUE·1·01·005/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '5',
    chapter_name: 'Excavación para Canales y Dársenas',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-01-005-04.pdf'
  },
  {
    name: 'N·CTR·PUE·1·01·006/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '6',
    chapter_name: 'Excavación para Estructuras',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-01-006-04.pdf'
  },
  {
    name: 'N·CTR·PUE·1·01·007/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '7',
    chapter_name: 'Bancos',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-01-007-04.pdf'
  },
  {
    name: 'N·CTR·PUE·1·01·008/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '8',
    chapter_name: 'Terraplenes',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-01-008-04.pdf'
  },
  {
    name: 'N·CTR·PUE·1·01·009/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '9',
    chapter_name: 'Rellenos',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-01-009-04.pdf'
  },
  {
    name: 'N·CTR·PUE·1·01·010/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '10',
    chapter_name: 'Recubrimiento de Taludes',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-01-010-04.pdf'
  },
  {
    name: 'N·CTR·PUE·1·01·011/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '11',
    chapter_name: 'Acarreos',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-01-011-04.pdf'
  },
  {
    name: 'N·CTR·PUE·1·01·012/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '12',
    chapter_name: 'Anclas Estabilizadoras',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-01-012-04.pdf'
  },
  {
    name: 'N·CTR·PUE·1·01·013/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '13',
    chapter_name: 'Concreto Lanzado',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-01-013-04.pdf'
  },
  {
    name: 'N·CTR·PUE·1·01·014/04',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '1',
    title_name: 'Terracerías',
    chapter_id: '14',
    chapter_name: 'Afinamiento de Taludes',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-01-014-04.pdf'
  },
  {
    name: 'N·CTR·PUE·1·02·001/06',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Obras de Protección',
    chapter_id: '1',
    chapter_name: 'Enrocamientos',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-02-001-06.pdf'
  },
  {
    name: 'N·CTR·PUE·1·02·002/06',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Obras de Protección',
    chapter_id: '2',
    chapter_name: 'Bermas',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-02-002-06.pdf'
  },
  {
    name: 'N·CTR·PUE·1·02·003/06',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Obras de Protección',
    chapter_id: '3',
    chapter_name: 'Elementos Precolados de Concreto',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-02-003-06.pdf'
  },
  {
    name: 'N·CTR·PUE·1·02·004/14',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Obras de Protección',
    chapter_id: '4',
    chapter_name: 'Gaviones y Colchones para Revestimiento',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-02-004-14.pdf'
  },
  {
    name: 'N·CTR·PUE·1·02·004/06',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Obras de Protección',
    chapter_id: '4',
    chapter_name: 'Gaviones y Colchones para Revestimiento',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-02-004-06.pdf'
  },
  {
    name: 'N·CTR·PUE·1·02·005/06',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Obras de Protección',
    chapter_id: '5',
    chapter_name: 'Bolsas',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-02-005-06.pdf'
  },
  {
    name: 'N·CTR·PUE·1·02·006/07',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Obras de Protección',
    chapter_id: '6',
    chapter_name: 'Filtros',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-02-006-07.pdf'
  },
  {
    name: 'N·CTR·PUE·1·02·007/07',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '2',
    title_name: 'Obras de Protección',
    chapter_id: '7',
    chapter_name: 'Geotextiles',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-02-007-07.pdf'
  },
  {
    name: 'N·CTR·PUE·1·03·001/06',
    type: 'Norma',
    book_id: 6,
    book_name: 'Construcción',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 1,
    part_name: 'Conceptos de Obra',
    title_id: '3',
    title_name: 'Dragado',
    chapter_id: '1',
    chapter_name: 'Dragado con Equipo Marino',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-CTR-PUE-1-03-001-06.pdf'
  },
  {
    name: 'N·CSV·CAR·1·03·004/16',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Evaluación',
    title_id: '3',
    title_name: 'Evaluación de pavimentos',
    chapter_id: '4',
    chapter_name: 'Determinación del Índice de Regularidad Internacional (IRI)',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-1-03-004-16.pdf'
  },
  {
    name: 'N·CSV·CAR·1·03·006/16',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Evaluación',
    title_id: '3',
    title_name: 'Evaluación de pavimentos',
    chapter_id: '6',
    chapter_name: 'Determinación de la Macrotextura (MAC)',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-1-03-006-16.pdf'
  },
  {
    name: 'N·CSV·CAR·1·03·007/17',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Evaluación',
    title_id: '3',
    title_name: 'Evaluación de pavimentos',
    chapter_id: '7',
    chapter_name: 'Determinación del Coeficiente de Fricción (CF)',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-1-03-007-17.pdf'
  },
  {
    name: 'N·CSV·CAR·1·03·008/18',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Evaluación',
    title_id: '3',
    title_name: 'Evaluación de pavimentos',
    chapter_id: '8',
    chapter_name: 'Determinación de los Deterioros Superficiales de los Pavimentos (DET)',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-1-03-008-18.pdf'
  },
  {
    name: 'N·CSV·CAR·1·03·009/16',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Evaluación',
    title_id: '3',
    title_name: 'Evaluación de pavimentos',
    chapter_id: '9',
    chapter_name: 'Determinación de la Profundidad de Roderas (PR)',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-1-03-009-16.pdf'
  },
  {
    name: 'N·CSV·CAR·1·03·010/17',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 1,
    part_name: 'Evaluación',
    title_id: '3',
    title_name: 'Evaluación de pavimentos',
    chapter_id: '10',
    chapter_name: 'Determinación de las Deflexiones de un Pavimento (DEF)',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-1-03-010-17.pdf'
  },
  {
    name: 'N·CSV·CAR·2·01·001/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '1',
    chapter_name: 'Limpieza de Cunetas y Contracunetas',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-01-001-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·01·002/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '2',
    chapter_name: 'Limpieza de Canales',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-01-002-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·01·003/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '3',
    chapter_name: 'Limpieza de Alcantarillas',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-01-003-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·01·004/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '4',
    chapter_name: 'Limpieza de Colectores',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-01-004-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·01·005/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '5',
    chapter_name: 'Limpieza de Lavaderos',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-01-005-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·01·006/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '6',
    chapter_name: 'Limpieza de Registros',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-01-006-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·01·007/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '7',
    chapter_name: 'Limpieza de Subdrenes',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-01-007-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·01·008/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '8',
    chapter_name: 'Limpieza de Vados',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-01-008-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·01·009/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '9',
    chapter_name: 'Limpieza de Obras Especiales de Control y Protección',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-01-009-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·02·001/10',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '1',
    chapter_name: 'Limpieza de la Superficie de Rodadura y Acotamientos (Nombre Actual)',
    year: 2010,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-02-001-10.pdf'
  },
  {
    name: 'N·CSV·CAR·2·02·001/00',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '1',
    chapter_name: 'Limpieza de la Superficie de Rodamiento y Acotamientos (Nombre anterior)',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-02-001-00.pdf'
  },
  {
    name: 'N·CSV·CAR·2·02·002/15',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '2',
    chapter_name: 'Sellado de Grietas Aisladas en Carpetas Asfálticas',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-02-002-15.pdf'
  },
  {
    name: 'N·CSV·CAR·2·02·002/00',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '2',
    chapter_name: 'Sellado de Grietas Aisladas en Carpetas Asfálticas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-02-002-00.pdf'
  },
  {
    name: 'N·CSV·CAR·2·02·003/16',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '3',
    chapter_name: 'Bacheo Superficial Aislado',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-02-003-16.pdf'
  },
  {
    name: 'N·CSV·CAR·2·02·003/15',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '3',
    chapter_name: 'Bacheo Superficial Aislado',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-02-003-15.pdf'
  },
  {
    name: 'N·CSV·CAR·2·02·003/00',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '3',
    chapter_name: 'Bacheo Superficial Aislado',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-02-003-00.pdf'
  },
  {
    name: 'N·CSV·CAR·2·02·004/15',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '4',
    chapter_name: 'Bacheo Profundo Aislado',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-02-004-15.pdf'
  },
  {
    name: 'N·CSV·CAR·2·02·004/03',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '4',
    chapter_name: 'Bacheo Profundo Aislado',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-02-004-03.pdf'
  },
  {
    name: 'N·CSV·CAR·2·02·004/00',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '4',
    chapter_name: 'Bacheo Profundo Aislado',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-02-004-00.pdf'
  },
  {
    name: 'N·CSV·CAR·2·02·005/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '5',
    chapter_name: 'Sellado de Grietas y Juntas en Losas de Concreto Hidráulico',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-02-005-02.pdf'
  },
  {
    name: 'N·CSV·CAR·2·03·001/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '3',
    title_name: 'Puentes y Estructuras',
    chapter_id: '1',
    chapter_name: 'Limpieza de Juntas de Dilatación',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-03-001-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·03·002/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '3',
    title_name: 'Puentes y Estructuras',
    chapter_id: '2',
    chapter_name: 'Limpieza de Parapetos, Banquetas y Camellones',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-03-002-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·03·003/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '3',
    title_name: 'Puentes y Estructuras',
    chapter_id: '3',
    chapter_name: 'Limpieza de Drenes',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-03-003-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·03·004/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '3',
    title_name: 'Puentes y Estructuras',
    chapter_id: '4',
    chapter_name: 'Limpieza de Estribos, Pilas, Columnas y Aleros',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-03-004-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·04·001/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '4',
    title_name: 'Túneles',
    chapter_id: '1',
    chapter_name: 'Impermeabilización de Revestimientos',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-04-001-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·04·002/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '4',
    title_name: 'Túneles',
    chapter_id: '2',
    chapter_name: 'Limpieza de Paredes y Bóvedas',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-04-002-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·05·001/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '1',
    chapter_name: 'Reposición de Marcas en el Pavimento',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-05-001-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·05·002/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '2',
    chapter_name: 'Reposición de Marcas en Guarniciones',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-05-002-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·05·003/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '3',
    chapter_name: 'Reposición de Marcas en Estructuras y Objetos Adyacentes a la Superficie de Rodadura',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-05-003-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·05·004/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '4',
    chapter_name: 'Limpieza de Vialetas y Botones',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-05-004-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·05·005/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '5',
    chapter_name: 'Limpieza de Señales Verticales',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-05-005-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·05·006/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '6',
    chapter_name: 'Limpieza de Defensas y Barreras Centrales',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-05-006-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·05·007/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '7',
    chapter_name: 'Reposición de Vialetas para Defensas y Barreras Centrales',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-05-007-01.pdf'
  },
  {
    name: 'N·CSV·CAR·2·05·011/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 2,
    part_name: 'Trabajos de Conservación Rutinaria',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '11',
    chapter_name: 'Instalación de Señalamiento y Dispositivos para Protección en Obras de Conservación',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-2-05-011-01.pdf'
  },
  {
    name: 'N·CSV·CAR·3·01·001/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '1',
    chapter_name: 'Reparación de Cunetas y Contracunetas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-01-001-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·01·002/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '2',
    chapter_name: 'Reparación de Canales',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-01-002-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·01·003/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '3',
    chapter_name: 'Reparación de Alcantarillas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-01-003-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·01·004/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '4',
    chapter_name: 'Reparación de Colectores',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-01-004-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·01·005/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '5',
    chapter_name: 'Reparación de Lavaderos',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-01-005-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·01·006/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '6',
    chapter_name: 'Reposición de Bordillos y Reparación de Guarniciones',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-01-006-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·01·007/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '7',
    chapter_name: 'Reparación de Registros',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-01-007-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·01·008/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '8',
    chapter_name: 'Reposición Aislada de Subdrenes y Geodrenes',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-01-008-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·01·009/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '9',
    chapter_name: 'Reparación de Vados',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-01-009-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·001/15',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '1',
    chapter_name: 'Renivelaciones Locales en Pavimentos Asfálticos',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-001-15.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·001/10',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '1',
    chapter_name: 'Renivelaciones Locales en Pavimentos Asfálticos',
    year: 2010,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-001-10.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·001/00',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '1',
    chapter_name: 'Renivelaciones Locales en Pavimentos Asfálticos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-001-00.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·002/15',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '2',
    chapter_name: 'Capas de Rodadura de un Riego',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-002-15.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·002/13',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '2',
    chapter_name: 'Capas de Rodadura de un Riego',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-002-13.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·002/09',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '2',
    chapter_name: 'Capas de Rodadura de un Riego. (Nombre anterior: Carpetas de un Riego)',
    year: 2009,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-002-09.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·002/00',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '2',
    chapter_name: 'Capas de Rodadura de un Riego. (Nombre anterior: Carpetas de un Riego)',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-002-00.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·003/15',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '3',
    chapter_name: 'Capas de Rodadura de Granulometría Abierta',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-003-15.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·003/10',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '3',
    chapter_name: 'Capas de Rodadura  de Granulometría Abierta. (Nombre anterior: Carpetas de Granulometría Abierta)',
    year: 2010,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-003-10.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·003/00',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '3',
    chapter_name: 'Capas de Rodadura  de Granulometría Abierta. (Nombre anterior: Carpetas de Granulometría Abierta)',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-003-00.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·004/15',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '4',
    chapter_name: 'Capas de Rodadura de Mortero Asfáltico',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-004-15.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·004/13',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '4',
    chapter_name: 'Capas de Rodadura  de Mortero Asfáltico',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-004-13.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·004/10',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '4',
    chapter_name: 'Capas de Rodadura  de Mortero Asfáltico. (Nombre anterior: Carpetas de Mortero Asfáltico)',
    year: 2010,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-004-10.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·004/09',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '4',
    chapter_name: 'Capas de Rodadura  de Mortero Asfáltico. (Nombre anterior: Carpetas de Mortero Asfáltico)',
    year: 2009,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-004-09.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·004/00',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '4',
    chapter_name: 'Capas de Rodadura  de Mortero Asfáltico. (Nombre anterior: Carpetas de Mortero Asfáltico)',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-004-00.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·005/14',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '5',
    chapter_name: 'Carpeta Asfáltica de Granulometría Densa',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-005-14.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·005/10',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '5',
    chapter_name: 'Carpeta Asfáltica de Granulometría Densa',
    year: 2010,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-005-10.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·005/06',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '5',
    chapter_name: 'Carpeta Asfáltica de Granulometría Densa',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-005-06.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·005/04',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '5',
    chapter_name: 'Carpeta Asfáltica de Granulometría Densa',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-005-04.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·005/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '5',
    chapter_name: 'Carpeta Asfáltica de Granulometría Densa',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-005-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·006/10',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '6',
    chapter_name: 'Fresado de la Superficie de Rodadura en Pavimentos Asfálticos. (Nombre anterior: Fresado de la Capa Asfáltica de Rodadura)',
    year: 2010,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-006-10.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·006/06',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '6',
    chapter_name: 'Fresado de la Superficie de Rodadura en Pavimentos Asfálticos. (Nombre anterior: Fresado de la Capa Asfáltica de Rodadura)',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-006-06.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·006/04',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '6',
    chapter_name: 'Fresado de la Superficie de Rodadura en Pavimentos Asfálticos. (Nombre anterior: Fresado de la Capa Asfáltica de Rodadura)',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-006-04.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·006/03',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '6',
    chapter_name: 'Fresado de la Superficie de Rodadura en Pavimentos Asfálticos. (Nombre anterior: Fresado de la Capa Asfáltica de Rodadura)',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-006-03.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·007/10',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '7',
    chapter_name: 'Recorte de Carpetas Asfálticas',
    year: 2010,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-007-10.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·007/03',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '7',
    chapter_name: 'Recorte de Carpetas Asfálticas',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-007-03.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·008/03',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '8',
    chapter_name: 'Recuperación en Caliente de Carpetas Asfálticas',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-008-03.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·009/06',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '9',
    chapter_name: 'Fresado de la Superficie de Rodadura en Pavimentos de Concreto Hidráulico',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-009-06.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·009/04',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '9',
    chapter_name: 'Fresado de la Superficie de Rodadura en Pavimentos de Concreto Hidráulico',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-009-04.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·009/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '9',
    chapter_name: 'Fresado de la Superficie de Rodadura en Pavimentos de Concreto Hidráulico',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-009-01.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·010/03',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '10',
    chapter_name: 'Reposición  Total o Parcial de Losas de Concreto Hidráulico',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-010-03.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·011/03',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '11',
    chapter_name: 'Reparación de Desconchaduras en Losas de Concreto Hidráulico',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-011-03.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·012/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '12',
    chapter_name: 'Estabilización de Losas de Concreto Hidráulico',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-012-01.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·013/03',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '13',
    chapter_name: 'Estabilización o Refuerzo de Estabilización de Revestimientos con Cloruro de Calcio',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-013-03.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·014/15',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '14',
    chapter_name: 'Capas de Rodadura de Granulometría Discontinua Tipo SMA',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-014-15.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·014/10',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '14',
    chapter_name: 'Capas de Rodadura de Granulometría Discontinua Tipo SMA',
    year: 2010,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-014-10.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·015/15',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '15',
    chapter_name: 'Capas de Rodadura de Granulometría Discontinua Tipo CASAA',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-015-15.pdf'
  },
  {
    name: 'N·CSV·CAR·3·02·015/10',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '15',
    chapter_name: 'Capas de Rodadura de Granulometría Discontinua Tipo CASAA',
    year: 2010,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-02-015-10.pdf'
  },
  {
    name: 'N·CSV·CAR·3·03·001/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '3',
    title_name: 'Puentes y Estructuras',
    chapter_id: '1',
    chapter_name: 'Calafateo de Fisuras',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-03-001-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·03·002/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '3',
    title_name: 'Puentes y Estructuras',
    chapter_id: '2',
    chapter_name: 'Reparación de Grietas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-03-002-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·03·003/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '3',
    title_name: 'Puentes y Estructuras',
    chapter_id: '3',
    chapter_name: 'Reparaciones y Resanes en Elementos de Concreto',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-03-003-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·03·004/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '3',
    title_name: 'Puentes y Estructuras',
    chapter_id: '4',
    chapter_name: 'Reposición del Sello en Juntas de Dilatación',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-03-004-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·03·005/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '3',
    title_name: 'Puentes y Estructuras',
    chapter_id: '5',
    chapter_name: 'Reparación de Parapetos y Banquetas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-03-005-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·04·001/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '4',
    title_name: 'Túneles',
    chapter_id: '1',
    chapter_name: 'Relleno de Oquedades',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-04-001-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·04·002/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '4',
    title_name: 'Túneles',
    chapter_id: '2',
    chapter_name: 'Reposición de Drenes Longitudinales',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-04-002-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·05·001/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '1',
    chapter_name: 'Reposición Parcial de Defensas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-05-001-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·05·002/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '2',
    chapter_name: 'Reparación de Barreras Centrales de Concreto Hidráulico',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-05-002-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·05·003/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '3',
    chapter_name: 'Reposición Aislada de Vialetas y Botones',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-05-003-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·05·004/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '4',
    chapter_name: 'Reposición Aislada de Señales Verticales',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-05-004-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·05·005/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '5',
    chapter_name: 'Reposición y Reparación de Reglas y Tubos Guía para Vados',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-05-005-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·05·006/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '6',
    chapter_name: 'Reposición de Indicadores de Alineamiento',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-05-006-02.pdf'
  },
  {
    name: 'N·CSV·CAR·3·05·007/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Trabajos de Conservación Periódica',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '7',
    chapter_name: 'Reposición y Reparación de Dispositivos Diversos',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-3-05-007-02.pdf'
  },
  {
    name: 'N·CSV·CAR·4·01·001/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '1',
    chapter_name: 'Reparación Mayor de Cunetas y Contracunetas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-01-001-02.pdf'
  },
  {
    name: 'N·CSV·CAR·4·01·002/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '2',
    chapter_name: 'Reparación Mayor de Canales',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-01-002-02.pdf'
  },
  {
    name: 'N·CSV·CAR·4·01·003/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '3',
    chapter_name: 'Reparación Mayor de Alcantarillas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-01-003-02.pdf'
  },
  {
    name: 'N·CSV·CAR·4·01·004/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '4',
    chapter_name: 'Reposición de Registros',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-01-004-02.pdf'
  },
  {
    name: 'N·CSV·CAR·4·01·005/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '1',
    title_name: 'Obras de Drenaje y Subdrenaje',
    chapter_id: '5',
    chapter_name: 'Reposición de Subdrenes y Geodrenes',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-01-005-02.pdf'
  },
  {
    name: 'N·CSV·CAR·4·02·001/03',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '1',
    chapter_name: 'Recuperación en Frío de Pavimentos Asfálticos',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-02-001-03.pdf'
  },
  {
    name: 'N·CSV·CAR·4·02·002/03',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '2',
    chapter_name: 'Demolición de Losas de Concreto Hidráulico',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-02-002-03.pdf'
  },
  {
    name: 'N·CSV·CAR·4·02·003/03',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '3',
    chapter_name: 'Recorte de Pavimentos',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-02-003-03.pdf'
  },
  {
    name: 'N·CSV·CAR·4·02·004/03',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '4',
    chapter_name: 'Construcción de Subbases o Bases Hidráulicas',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-02-004-03.pdf'
  },
  {
    name: 'N·CSV·CAR·4·02·005/14',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '5',
    chapter_name: 'Construcción de Subbases o Bases Estabilizadas',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-02-005-14.pdf'
  },
  {
    name: 'N·CSV·CAR·4·02·005/03',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '5',
    chapter_name: 'Construcción de Subbases o Bases Estabilizadas',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-02-005-03.pdf'
  },
  {
    name: 'N·CSV·CAR·4·02·006/03',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '6',
    chapter_name: 'Construcción de Subbases y Bases de Concreto Compactado con Rodillo',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-02-006-03.pdf'
  },
  {
    name: 'N·CSV·CAR·4·02·007/03',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '2',
    title_name: 'Pavimentos',
    chapter_id: '7',
    chapter_name: 'Construcción de Carpetas y Carpetas Ultradelgadas de Concreto Hidráulico',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-02-007-03.pdf'
  },
  {
    name: 'N·CSV·CAR·4·03·001/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '3',
    title_name: 'Puentes y Estructuras',
    chapter_id: '1',
    chapter_name: 'Remoción de Carpeta Asfáltica en Puentes',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-03-001-02.pdf'
  },
  {
    name: 'N·CSV·CAR·4·03·002/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '3',
    title_name: 'Puentes y Estructuras',
    chapter_id: '2',
    chapter_name: 'Reposición de Juntas de Dilatación',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-03-002-02.pdf'
  },
  {
    name: 'N·CSV·CAR·4·04·001/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '4',
    title_name: 'Túneles',
    chapter_id: '1',
    chapter_name: 'Reparación del Sistema de Iluminación',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-04-001-02.pdf'
  },
  {
    name: 'N·CSV·CAR·4·04·002/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '4',
    title_name: 'Túneles',
    chapter_id: '2',
    chapter_name: 'Reparación del Sistema de Ventilación',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-04-002-02.pdf'
  },
  {
    name: 'N·CSV·CAR·4·05·001/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '1',
    chapter_name: 'Reposición Total de Vialetas y Botones',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-05-001-02.pdf'
  },
  {
    name: 'N·CSV·CAR·4·05·002/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '2',
    chapter_name: 'Reposición Total de Señalamiento Vertical',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-05-002-02.pdf'
  },
  {
    name: 'N·CSV·CAR·4·05·003/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '3',
    chapter_name: 'Reposición Total de Defensas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-05-003-02.pdf'
  },
  {
    name: 'N·CSV·CAR·4·05·004/02',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '5',
    title_name: 'Señalamiento y Dispositivos de Seguridad',
    chapter_id: '4',
    chapter_name: 'Reposición Total de Barreras Centrales de Concreto Hidráulico',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-4-05-004-02.pdf'
  },
  {
    name: 'N·CSV·CAR·6·01·005/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Obras Marginales en Carreteras en Operación',
    title_id: '1',
    title_name: 'Instalaciones para Fibra Óptica',
    chapter_id: '5',
    chapter_name: 'Poliductos para Fibra Óptica en Caminos Rurales en Operación',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-6-01-005-01.pdf'
  },
  {
    name: 'N·CSV·CAR·6·01·006/01',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Obras Marginales en Carreteras en Operación',
    title_id: '1',
    title_name: 'Instalaciones para Fibra Óptica',
    chapter_id: '6',
    chapter_name: 'Registros para Fibra Óptica en Caminos Rurales en Operación',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-6-01-006-01.pdf'
  },
  {
    name: 'N·CSV·CAR·6·01·007/19',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Obras Marginales en Carreteras en Operación',
    title_id: '1',
    title_name: 'Instalaciones para Fibra Óptica',
    chapter_id: '7',
    chapter_name: 'Tritubos para Fibra Óptica en el Acotamiento de Carreteras en Operación con Pavimento Asfáltico',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-6-01-007-19.pdf'
  },
  {
    name: 'N·CSV·CAR·6·01·007/13',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Obras Marginales en Carreteras en Operación',
    title_id: '1',
    title_name: 'Instalaciones para Fibra Óptica',
    chapter_id: '7',
    chapter_name: 'Tritubos para Fibra Óptica en el Acotamiento de Carreteras en Operación',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-6-01-007-13.pdf'
  },
  {
    name: 'N·CSV·CAR·6·01·007/11',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Obras Marginales en Carreteras en Operación',
    title_id: '1',
    title_name: 'Instalaciones para Fibra Óptica',
    chapter_id: '7',
    chapter_name: 'Tritubos para Fibra Óptica en el Acotamiento de Carreteras en Operación',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-6-01-007-11.pdf'
  },
  {
    name: 'N·CSV·CAR·6·01·008/11',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 6,
    part_name: 'Obras Marginales en Carreteras en Operación',
    title_id: '1',
    title_name: 'Instalaciones para Fibra Óptica',
    chapter_id: '8',
    chapter_name: 'Registros para Tritubos para Fibra Óptica de Carreteras en Operación',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CSV-CAR-6-01-008-11.pdf'
  },
  {
    name: 'N·CSV·PUE·4·02·006/17',
    type: 'Norma',
    book_id: 7,
    book_name: 'Conservación',
    theme_id: '4',
    theme_name: 'Puertos',
    part_id: 4,
    part_name: 'Trabajos de Reconstrucción',
    title_id: '2',
    title_name: 'Obras de Atraque y Amarre',
    chapter_id: '6',
    chapter_name: 'Instalación de Cubiertas Integrales de Zinc en Pilas y Pilotes',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/N-CSV-PUE-4-02-006-17.pdf'
  },
  {
    name: 'N·OPR·CAR·3·01/12',
    type: 'Norma',
    book_id: 8,
    book_name: 'Operación',
    theme_id: '1',
    theme_name: 'Carreteras',
    part_id: 3,
    part_name: 'Sistema de Información de Carreteras',
    title_id: '1',
    title_name: 'Obtención y Presentación de Datos Geoespaciales',
    chapter_id: null,
    chapter_name: null,
    year: 2012,
    url: 'https://normas.imt.mx/normativa/N-OPR-CAR-3-01-12.pdf'
  },
  {
    name: 'N·CAL·1·01/18',
    type: 'Norma',
    book_id: 9,
    book_name: 'Control y Aseguramiento de Calidad',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Control de Calidad',
    title_id: '1',
    title_name: 'Ejecución del Control de Calidad durante la Construcción o Conservación. (Nombre anterior: Ejecución del Control de Calidad durante la Construcción o Conservación',
    chapter_id: null,
    chapter_name: null,
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-CAL-1-01-18.pdf'
  },
  {
    name: 'N·CAL·1·01/05',
    type: 'Norma',
    book_id: 9,
    book_name: 'Control y Aseguramiento de Calidad',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Control de Calidad',
    title_id: '1',
    title_name: 'Ejecución del Control de Calidad durante la Construcción o Conservación. (Nombre anterior: Ejecución del Control de Calidad durante la Construcción y/o Conservación)',
    chapter_id: null,
    chapter_name: null,
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-CAL-1-01-05.pdf'
  },
  {
    name: 'N·CAL·1·01/00',
    type: 'Norma',
    book_id: 9,
    book_name: 'Control y Aseguramiento de Calidad',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Control de Calidad',
    title_id: '1',
    title_name: 'Ejecución del Control de Calidad durante la Construcción o Conservación. (Nombre anterior: Ejecución del Control de Calidad durante la Construcción y/o Conservación)',
    chapter_id: null,
    chapter_name: null,
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CAL-1-01-00.pdf'
  },
  {
    name: 'M·CAL·1·02/01',
    type: 'Manual',
    book_id: 9,
    book_name: 'Control y Aseguramiento de Calidad',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Control de Calidad',
    title_id: '2',
    title_name: 'Criterios Estadísticos de Muestreo',
    chapter_id: null,
    chapter_name: null,
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-CAL-1-02-01.pdf'
  },
  {
    name: 'M·CAL·1·03/03',
    type: 'Manual',
    book_id: 9,
    book_name: 'Control y Aseguramiento de Calidad',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Control de Calidad',
    title_id: '3',
    title_name: 'Análisis Estadísticos de Control de Calidad',
    chapter_id: null,
    chapter_name: null,
    year: 2003,
    url: 'https://normas.imt.mx/normativa/M-CAL-1-03-03.pdf'
  },
  {
    name: 'N·CAL·2·05·001/05',
    type: 'Norma',
    book_id: 9,
    book_name: 'Control y Aseguramiento de Calidad',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Aseguramiento de Calidad',
    title_id: '5',
    title_name: 'Calificación y Aprobación de Laboratorios',
    chapter_id: '1',
    chapter_name: 'Aprobación de Laboratorios',
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-CAL-2-05-001-05.pdf'
  },
  {
    name: 'N·CAL·2·05·001/01',
    type: 'Norma',
    book_id: 9,
    book_name: 'Control y Aseguramiento de Calidad',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Aseguramiento de Calidad',
    title_id: '5',
    title_name: 'Calificación y Aprobación de Laboratorios',
    chapter_id: '1',
    chapter_name: 'Aprobación de Laboratorios',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CAL-2-05-001-01.pdf'
  },
  {
    name: 'N·CMT·1·01/16',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Materiales para Terracerías',
    title_id: '1',
    title_name: 'Materiales para Terraplén',
    chapter_id: null,
    chapter_name: null,
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-CMT-1-01-16.pdf'
  },
  {
    name: 'N·CMT·1·01/02',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Materiales para Terracerías',
    title_id: '1',
    title_name: 'Materiales para Terraplén',
    chapter_id: null,
    chapter_name: null,
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CMT-1-01-02.pdf'
  },
  {
    name: 'N·CMT·1·02/02',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Materiales para Terracerías',
    title_id: '2',
    title_name: 'Materiales para Subyacente',
    chapter_id: null,
    chapter_name: null,
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CMT-1-02-02.pdf'
  },
  {
    name: 'N·CMT·1·03/02',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Materiales para Terracerías',
    title_id: '3',
    title_name: 'Materiales para Subrasante',
    chapter_id: null,
    chapter_name: null,
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CMT-1-03-02.pdf'
  },
  {
    name: 'N·CMT·1·04/19',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Materiales para Terracerías',
    title_id: '4',
    title_name: 'Materiales Tratados con Cal para Terracerías',
    chapter_id: null,
    chapter_name: null,
    year: 2019,
    url: 'https://normas.imt.mx/normativa/N-CMT-1-04-19.pdf'
  },
  {
    name: 'N·CMT·2·01·001/02',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '1',
    title_name: 'Materiales para Mamposterías',
    chapter_id: '1',
    chapter_name: 'Ladrillos y Bloques Cerámicos',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-01-001-02.pdf'
  },
  {
    name: 'N·CMT·2·01·002/02',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '1',
    title_name: 'Materiales para Mamposterías',
    chapter_id: '2',
    chapter_name: 'Bloques de Cemento, Tabiques y Tabicones',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-01-002-02.pdf'
  },
  {
    name: 'N·CMT·2·01·003/02',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '1',
    title_name: 'Materiales para Mamposterías',
    chapter_id: '3',
    chapter_name: 'Fragmentos de Roca',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-01-003-02.pdf'
  },
  {
    name: 'N·CMT·2·01·004/02',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '1',
    title_name: 'Materiales para Mamposterías',
    chapter_id: '4',
    chapter_name: 'Morteros',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-01-004-02.pdf'
  },
  {
    name: 'N·CMT·2·02·001/02',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '1',
    chapter_name: 'Calidad del Cemento Pórtland',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-02-001-02.pdf'
  },
  {
    name: 'N·CMT·2·02·002/19',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '2',
    chapter_name: 'Calidad de Agregados Pétreos para Concreto Hidráulico',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-02-002-19.pdf'
  },
  {
    name: 'N·CMT·2·02·002/02',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '2',
    chapter_name: 'Calidad de Agregados Pétreos para Concreto Hidráulico',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-02-002-02.pdf'
  },
  {
    name: 'N·CMT·2·02·003/02',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '3',
    chapter_name: 'Calidad del Agua para Concreto Hidráulico',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-02-003-02.pdf'
  },
  {
    name: 'N·CMT·2·02·004/18',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '4',
    chapter_name: 'Calidad de Aditivos Químicos para Concreto Hidráulico',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-02-004-18.pdf'
  },
  {
    name: 'N·CMT·2·02·004/04',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '4',
    chapter_name: 'Calidad de Aditivos Químicos para Concreto Hidráulico',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-02-004-04.pdf'
  },
  {
    name: 'N·CMT·2·02·005/04',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '5',
    chapter_name: 'Calidad del Concreto Hidráulico',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-02-005-04.pdf'
  },
  {
    name: 'N·CMT·2·02·006/04',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '6',
    chapter_name: 'Calidad de Membranas de Curado para Concreto Hidráulico',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-02-006-04.pdf'
  },
  {
    name: 'N·CMT·2·03·001/07',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '3',
    title_name: 'Acero y Productos de Acero',
    chapter_id: '1',
    chapter_name: 'Acero de Refuerzo para Concreto Hidráulico',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-03-001-07.pdf'
  },
  {
    name: 'N·CMT·2·03·001/04',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '3',
    title_name: 'Acero y Productos de Acero',
    chapter_id: '1',
    chapter_name: 'Acero de Refuerzo para Concreto Hidráulico',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-03-001-04.pdf'
  },
  {
    name: 'N·CMT·2·03·002/04',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '3',
    title_name: 'Acero y Productos de Acero',
    chapter_id: '2',
    chapter_name: 'Acero de Presfuerzo para Concreto Hidráulico',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-03-002-04.pdf'
  },
  {
    name: 'N·CMT·2·03·003/04',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '3',
    title_name: 'Acero y Productos de Acero',
    chapter_id: '3',
    chapter_name: 'Acero Estructural',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-03-003-04.pdf'
  },
  {
    name: 'N·CMT·2·03·004/06',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '3',
    title_name: 'Acero y Productos de Acero',
    chapter_id: '4',
    chapter_name: 'Acero de Refuerzo Galvanizado para Concreto Hidráulico',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-03-004-06.pdf'
  },
  {
    name: 'N·CMT·2·04·001/04',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '4',
    title_name: 'Soldadura',
    chapter_id: '1',
    chapter_name: 'Soldadura al Arco Eléctrico',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-04-001-04.pdf'
  },
  {
    name: 'N·CMT·2·07/04',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '7',
    title_name: 'Pinturas para Recubrimiento de Estructuras',
    chapter_id: null,
    chapter_name: null,
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-07-04.pdf'
  },
  {
    name: 'N·CMT·2·08/15',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '8',
    title_name: 'Placas y Apoyos Integrales de Neopreno',
    chapter_id: null,
    chapter_name: null,
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-08-15.pdf'
  },
  {
    name: 'N·CMT·2·09/07',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '9',
    title_name: 'Apoyos Especiales para Puentes',
    chapter_id: null,
    chapter_name: null,
    year: 2007,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-09-07.pdf'
  },
  {
    name: 'N·CMT·2·10·004/17',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '10',
    title_name: 'Productos Anticorrosivos',
    chapter_id: '4',
    chapter_name: 'Cubiertas Integrales de Zinc',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/N-CMT-2-10-004-17.pdf'
  },
  {
    name: 'N·CMT·3·01/01',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Materiales para Obras de Drenaje y Subdrenaje',
    title_id: '1',
    title_name: 'Tubos de Concreto sin Refuerzo',
    chapter_id: null,
    chapter_name: null,
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CMT-3-01-01.pdf'
  },
  {
    name: 'N·CMT·3·02/04',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Materiales para Obras de Drenaje y Subdrenaje',
    title_id: '2',
    title_name: 'Tubos de Concreto con Refuerzo',
    chapter_id: null,
    chapter_name: null,
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CMT-3-02-04.pdf'
  },
  {
    name: 'N·CMT·3·02/01',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Materiales para Obras de Drenaje y Subdrenaje',
    title_id: '2',
    title_name: 'Tubos de Concreto con Refuerzo',
    chapter_id: null,
    chapter_name: null,
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CMT-3-02-01.pdf'
  },
  {
    name: 'N·CMT·3·03/01',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Materiales para Obras de Drenaje y Subdrenaje',
    title_id: '3',
    title_name: 'Tubos y Arcos de Lámina Corrugada de Acero',
    chapter_id: null,
    chapter_name: null,
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CMT-3-03-01.pdf'
  },
  {
    name: 'N·CMT·3·04·001/05',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Materiales para Obras de Drenaje y Subdrenaje',
    title_id: '4',
    title_name: 'Materiales para Subdrenes',
    chapter_id: '1',
    chapter_name: 'Filtros',
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-CMT-3-04-001-05.pdf'
  },
  {
    name: 'N·CMT·3·04·002/05',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Materiales para Obras de Drenaje y Subdrenaje',
    title_id: '4',
    title_name: 'Materiales para Subdrenes',
    chapter_id: '2',
    chapter_name: 'Tubos de Concreto para Subdrenes',
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-CMT-3-04-002-05.pdf'
  },
  {
    name: 'N·CMT·3·04·003/05',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Materiales para Obras de Drenaje y Subdrenaje',
    title_id: '4',
    title_name: 'Materiales para Subdrenes',
    chapter_id: '3',
    chapter_name: 'Tubos de Policloruro de Vinilo (PVC) para Sistemas de Subdrenaje',
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-CMT-3-04-003-05.pdf'
  },
  {
    name: 'N·CMT·3·06/10',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Materiales para Obras de Drenaje y Subdrenaje',
    title_id: '6',
    title_name: 'Tubos Corrugados de Polietileno de Alta Densidad',
    chapter_id: null,
    chapter_name: null,
    year: 2010,
    url: 'https://normas.imt.mx/normativa/N-CMT-3-06-10.pdf'
  },
  {
    name: 'N·CMT·3·06/09',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Materiales para Obras de Drenaje y Subdrenaje',
    title_id: '6',
    title_name: 'Tubos Corrugados de Polietileno de Alta Densidad',
    chapter_id: null,
    chapter_name: null,
    year: 2009,
    url: 'https://normas.imt.mx/normativa/N-CMT-3-06-09.pdf'
  },
  {
    name: 'N·CMT·3·07/16',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 3,
    part_name: 'Materiales para Obras de Drenaje y Subdrenaje',
    title_id: '7',
    title_name: 'Cajones Prefabricados de Concreto Hidráulico Reforzado',
    chapter_id: null,
    chapter_name: null,
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-CMT-3-07-16.pdf'
  },
  {
    name: 'N·CMT·4·01/02',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '1',
    title_name: 'Materiales para Revestimiento',
    chapter_id: null,
    chapter_name: null,
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-01-02.pdf'
  },
  {
    name: 'N·CMT·4·02·001/16',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '2',
    title_name: 'Materiales para Subbases y Bases',
    chapter_id: '1',
    chapter_name: 'Materiales para Subbases',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-02-001-16.pdf'
  },
  {
    name: 'N·CMT·4·02·001/11',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '2',
    title_name: 'Materiales para Subbases y Bases',
    chapter_id: '1',
    chapter_name: 'Materiales para Subbases',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-02-001-11.pdf'
  },
  {
    name: 'N·CMT·4·02·001/04',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '2',
    title_name: 'Materiales para Subbases y Bases',
    chapter_id: '1',
    chapter_name: 'Materiales para Subbases',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-02-001-04.pdf'
  },
  {
    name: 'N·CMT·4·02·002/16',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '2',
    title_name: 'Materiales para Subbases y Bases',
    chapter_id: '2',
    chapter_name: 'Materiales para Bases Hidráulicas',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-02-002-16.pdf'
  },
  {
    name: 'N·CMT·4·02·002/11',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '2',
    title_name: 'Materiales para Subbases y Bases',
    chapter_id: '2',
    chapter_name: 'Materiales para Bases Hidráulicas',
    year: 2011,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-02-002-11.pdf'
  },
  {
    name: 'N·CMT·4·02·002/04',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '2',
    title_name: 'Materiales para Subbases y Bases',
    chapter_id: '2',
    chapter_name: 'Materiales para Bases Hidráulicas',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-02-002-04.pdf'
  },
  {
    name: 'N·CMT·4·02·003/19',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '2',
    title_name: 'Materiales para Subbases y Bases',
    chapter_id: '3',
    chapter_name: 'Materiales para Bases Tratadas',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-02-003-19.pdf'
  },
  {
    name: 'N·CMT·4·02·003/16',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '2',
    title_name: 'Materiales para Subbases y Bases',
    chapter_id: '3',
    chapter_name: 'Materiales para Bases Tratadas',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-02-003-16.pdf'
  },
  {
    name: 'N·CMT·4·02·003/04',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '2',
    title_name: 'Materiales para Subbases y Bases',
    chapter_id: '3',
    chapter_name: 'Materiales para Bases Tratadas',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-02-003-04.pdf'
  },
  {
    name: 'N·CMT·4·03·001/17',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '3',
    title_name: 'Materiales para Estabilizaciones',
    chapter_id: '1',
    chapter_name: 'Cal para Estabilizaciones',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-03-001-17.pdf'
  },
  {
    name: 'N·CMT·4·03·001/02',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '3',
    title_name: 'Materiales para Estabilizaciones',
    chapter_id: '1',
    chapter_name: 'Cal para Estabilizaciones',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-03-001-02.pdf'
  },
  {
    name: 'N·CMT·4·04/17',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: null,
    chapter_name: null,
    year: 2017,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-04-17.pdf'
  },
  {
    name: 'N·CMT·4·04/08',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: null,
    chapter_name: null,
    year: 2008,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-04-08.pdf'
  },
  {
    name: 'N·CMT·4·04/03',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: null,
    chapter_name: null,
    year: 2003,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-04-03.pdf'
  },
  {
    name: 'N·CMT·4·04/02',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: null,
    chapter_name: null,
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-04-02.pdf'
  },
  {
    name: 'N·CMT·4·04/01',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: null,
    chapter_name: null,
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-04-01.pdf'
  },
  {
    name: 'N·CMT·4·05·001/06',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '1',
    chapter_name: 'Calidad de Materiales Asfálticos',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-05-001-06.pdf'
  },
  {
    name: 'N·CMT·4·05·001/05',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '1',
    chapter_name: 'Calidad de Materiales Asfálticos',
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-05-001-05.pdf'
  },
  {
    name: 'N·CMT·4·05·001/00',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '1',
    chapter_name: 'Calidad de Materiales Asfálticos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-05-001-00.pdf'
  },
  {
    name: 'N·CMT·4·05·002/06',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '2',
    chapter_name: 'Calidad de Materiales Asfálticos Modificados',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-05-002-06.pdf'
  },
  {
    name: 'N·CMT·4·05·002/01',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '2',
    chapter_name: 'Calidad de Materiales Asfálticos Modificados',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-05-002-01.pdf'
  },
  {
    name: 'N·CMT·4·05·003/16',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '3',
    chapter_name: 'Calidad de Mezclas Asfálticas para Carreteras',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-05-003-16.pdf'
  },
  {
    name: 'N·CMT·4·05·003/08',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '3',
    chapter_name: 'Calidad de Mezclas Asfálticas para Carreteras',
    year: 2008,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-05-003-08.pdf'
  },
  {
    name: 'N·CMT·4·05·003/02',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '3',
    chapter_name: 'Calidad de Mezclas Asfálticas para Carreteras',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-05-003-02.pdf'
  },
  {
    name: 'N·CMT·4·05·004/18',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '4',
    chapter_name: 'Calidad de Cementos Asfálticos según su Grado de Desempeño (PG)',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-05-004-18.pdf'
  },
  {
    name: 'N·CMT·4·05·004/08',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '4',
    chapter_name: 'Calidad de Materiales Asfálticos Grado PG',
    year: 2008,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-05-004-08.pdf'
  },
  {
    name: 'N·CMT·4·05·004/05',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '4',
    chapter_name: 'Calidad de Materiales Asfálticos Grado PG',
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-05-004-05.pdf'
  },
  {
    name: 'N·CMT·4·06·001/19',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para Pavimentos',
    title_id: '6',
    title_name: 'Materiales para Carpetas de Concreto Hidráulico',
    chapter_id: '1',
    chapter_name: 'Calidad de Agregados para Carpetas de Concreto Hidráulico',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/N-CMT-4-06-001-19.pdf'
  },
  {
    name: 'N·CMT·5·01·001/13',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '1',
    title_name: 'Pinturas',
    chapter_id: '1',
    chapter_name: 'Pinturas para Señalamiento Horizontal',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-CMT-5-01-001-13.pdf'
  },
  {
    name: 'N·CMT·5·01·001/05',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '1',
    title_name: 'Pinturas',
    chapter_id: '1',
    chapter_name: 'Pinturas para Señalamiento Horizontal',
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-CMT-5-01-001-05.pdf'
  },
  {
    name: 'N·CMT·5·01·002/05',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '1',
    title_name: 'Pinturas',
    chapter_id: '2',
    chapter_name: 'Pinturas para Señalamiento Vertical',
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-CMT-5-01-002-05.pdf'
  },
  {
    name: 'N·CMT·5·02·001/05',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '2',
    title_name: 'Acero para Señales y Dispositivos de Seguridad',
    chapter_id: '1',
    chapter_name: 'Calidad de Defensas',
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-CMT-5-02-001-05.pdf'
  },
  {
    name: 'N·CMT·5·02·002/05',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '2',
    title_name: 'Acero para Señales y Dispositivos de Seguridad',
    chapter_id: '2',
    chapter_name: 'Lámina y Estructuras para Señalamiento Vertical',
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-CMT-5-02-002-05.pdf'
  },
  {
    name: 'N·CMT·5·03·001/13',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '3',
    title_name: 'Materiales Reflejantes',
    chapter_id: '1',
    chapter_name: 'Calidad de Películas Reflejantes',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-CMT-5-03-001-13.pdf'
  },
  {
    name: 'N·CMT·5·03·001/05',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '3',
    title_name: 'Materiales Reflejantes',
    chapter_id: '1',
    chapter_name: 'Calidad de Películas Reflejantes. (Nombre anterior: Calidad de Películas Retrorreflejantes)',
    year: 2005,
    url: 'https://normas.imt.mx/normativa/N-CMT-5-03-001-05.pdf'
  },
  {
    name: 'N·CMT·5·03·001/00',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '3',
    title_name: 'Materiales Reflejantes',
    chapter_id: '1',
    chapter_name: 'Calidad de Películas Reflejantes. (Nombre anterior: Calidad de Películas Retrorreflejantes)',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/N-CMT-5-03-001-00.pdf'
  },
  {
    name: 'N·CMT·5·04/13',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '4',
    title_name: 'Botones y Botones Reflejantes',
    chapter_id: null,
    chapter_name: null,
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-CMT-5-04-13.pdf'
  },
  {
    name: 'N·CMT·5·04/08',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '4',
    title_name: 'Botones y Botones Reflejantes',
    chapter_id: null,
    chapter_name: null,
    year: 2008,
    url: 'https://normas.imt.mx/normativa/N-CMT-5-04-08.pdf'
  },
  {
    name: 'N·CMT·6·01·001/13',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 6,
    part_name: 'Materiales Diversos',
    title_id: '1',
    title_name: 'Geosintéticos',
    chapter_id: '1',
    chapter_name: 'Geotextiles para Terracerías',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-CMT-6-01-001-13.pdf'
  },
  {
    name: 'N·CMT·6·01·002/13',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 6,
    part_name: 'Materiales Diversos',
    title_id: '1',
    title_name: 'Geosintéticos',
    chapter_id: '2',
    chapter_name: 'Geotextiles para Obras de Subdrenaje',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-CMT-6-01-002-13.pdf'
  },
  {
    name: 'N·CMT·6·01·003/13',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 6,
    part_name: 'Materiales Diversos',
    title_id: '1',
    title_name: 'Geosintéticos',
    chapter_id: '3',
    chapter_name: 'Geotextiles para Subbases y Bases',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-CMT-6-01-003-13.pdf'
  },
  {
    name: 'N·CMT·6·01·004/13',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 6,
    part_name: 'Materiales Diversos',
    title_id: '1',
    title_name: 'Geosintéticos',
    chapter_id: '4',
    chapter_name: 'Geotextiles para Mezclas Asfálticas en Caliente',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-CMT-6-01-004-13.pdf'
  },
  {
    name: 'N·CMT·6·01·005/16',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 6,
    part_name: 'Materiales Diversos',
    title_id: '1',
    title_name: 'Geosintéticos',
    chapter_id: '5',
    chapter_name: 'Geomallas de Polímeros Sintéticos para Terracerías, Subbases y Bases',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/N-CMT-6-01-005-16.pdf'
  },
  {
    name: 'N·CMT·6·01·005/14',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 6,
    part_name: 'Materiales Diversos',
    title_id: '1',
    title_name: 'Geosintéticos',
    chapter_id: '5',
    chapter_name: 'Geomallas de Polímeros para Terracerías, Subbases y Bases',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-CMT-6-01-005-14.pdf'
  },
  {
    name: 'N·CMT·6·01·006/15',
    type: 'Norma',
    book_id: 10,
    book_name: 'Características de los Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 6,
    part_name: 'Materiales Diversos',
    title_id: '1',
    title_name: 'Geosintéticos',
    chapter_id: '6',
    chapter_name: 'Geomallas de Fibra de Vidrio para Mezclas Asfálticas en Caliente',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-CMT-6-01-006-15.pdf'
  },
  {
    name: 'N·EIP·1·01·001/14',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Calidad de los Equipos y Sistemas',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '1',
    chapter_name: 'Tableros de Señalamiento Variable con LED\'S',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-EIP-1-01-001-14.pdf'
  },
  {
    name: 'N·EIP·1·01·002/14',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Calidad de los Equipos y Sistemas',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '2',
    chapter_name: 'Tableros de Señalamiento Cambiable con LED\'S',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-EIP-1-01-002-14.pdf'
  },
  {
    name: 'N·EIP·1·01·003/14',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Calidad de los Equipos y Sistemas',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '3',
    chapter_name: 'Tableros de Señalamiento de Encendido-Apagado con LED\'S',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-EIP-1-01-003-14.pdf'
  },
  {
    name: 'N·EIP·1·01·007/13',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Calidad de los Equipos y Sistemas',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '7',
    chapter_name: 'Antenas de Telepeaje',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-EIP-1-01-007-13.pdf'
  },
  {
    name: 'N·EIP·1·01·008/13',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Calidad de los Equipos y Sistemas',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '8',
    chapter_name: 'Transpondedores de Telepeaje',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-EIP-1-01-008-13.pdf'
  },
  {
    name: 'N·EIP·1·01·009/15',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Calidad de los Equipos y Sistemas',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '9',
    chapter_name: 'Unidad Central de Procesamiento del Sistema de Telepeaje',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-EIP-1-01-009-15.pdf'
  },
  {
    name: 'N·EIP·1·01·010/14',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Calidad de los Equipos y Sistemas',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '10',
    chapter_name: 'Cámaras de Video para Vigilancia',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-EIP-1-01-010-14.pdf'
  },
  {
    name: 'N·EIP·1·01·011/14',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Calidad de los Equipos y Sistemas',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '11',
    chapter_name: 'Cámaras de Video para Reconocimiento de Placas',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-EIP-1-01-011-14.pdf'
  },
  {
    name: 'N·EIP·1·01·012/14',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Calidad de los Equipos y Sistemas',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '12',
    chapter_name: 'Cámaras de Video para Detección Automática de Incidentes',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-EIP-1-01-012-14.pdf'
  },
  {
    name: 'N·EIP·1·01·013/15',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Calidad de los Equipos y Sistemas',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '13',
    chapter_name: 'Unidad Central de Procesamiento del Sistema de Pesaje Dinámico y Dimensionamiento Vehicular',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-EIP-1-01-013-15.pdf'
  },
  {
    name: 'N·EIP·1·01·014/15',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Calidad de los Equipos y Sistemas',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '14',
    chapter_name: 'Sensores Piezoeléctricos de Cuarzo',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-EIP-1-01-014-15.pdf'
  },
  {
    name: 'N·EIP·1·01·015/14',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Calidad de los Equipos y Sistemas',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '15',
    chapter_name: 'Lazos Inductivos',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-EIP-1-01-015-14.pdf'
  },
  {
    name: 'N·EIP·2·01·001/13',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Protocolos de Comunicación',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '1',
    chapter_name: 'Protocolos de Comunicación para Tableros de Señalamiento Variable con LED’s',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-EIP-2-01-001-13.pdf'
  },
  {
    name: 'N·EIP·2·01·002/13',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Protocolos de Comunicación',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '2',
    chapter_name: 'Protocolos de Comunicación para Tableros de Señalamiento Cambiable con LED´s',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-EIP-2-01-002-13.pdf'
  },
  {
    name: 'N·EIP·2·01·003/13',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Protocolos de Comunicación',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '3',
    chapter_name: 'Protocolos de Comunicación para Tableros de Señalamiento de Encendido-Apagado con LED´s',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-EIP-2-01-003-13.pdf'
  },
  {
    name: 'N·EIP·2·01·004/13',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Protocolos de Comunicación',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '4',
    chapter_name: 'Protocolos de Comunicación para Tableros de Señalamiento de Velocidad Variable con LED’s',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-EIP-2-01-004-13.pdf'
  },
  {
    name: 'N·EIP·2·01·005/13',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Protocolos de Comunicación',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '5',
    chapter_name: 'Protocolos de Comunicación para Tableros de Señalamiento de Velocidad Real con LED’s',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-EIP-2-01-005-13.pdf'
  },
  {
    name: 'N·EIP·2·01·006/13',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Protocolos de Comunicación',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '6',
    chapter_name: 'Protocolos de Comunicación para Tableros de Señalamiento de Tiempo Estimado de Viaje con LED’s',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-EIP-2-01-006-13.pdf'
  },
  {
    name: 'N·EIP·2·01·007/13',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Protocolos de Comunicación',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '7',
    chapter_name: 'Protocolos de Comunicación para Antenas de Telepeaje',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-EIP-2-01-007-13.pdf'
  },
  {
    name: 'N·EIP·2·01·008/13',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Protocolos de Comunicación',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '8',
    chapter_name: 'Protocolos de Comunicación para Transpondedores de Telepeaje',
    year: 2013,
    url: 'https://normas.imt.mx/normativa/N-EIP-2-01-008-13.pdf'
  },
  {
    name: 'N·EIP·2·01·009/14',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Protocolos de Comunicación',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '9',
    chapter_name: 'Protocolos de Comunicación para la Unidad Central de Procesamiento del Sistema de Telepeaje',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-EIP-2-01-009-14.pdf'
  },
  {
    name: 'N·EIP·2·01·010/14',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Protocolos de Comunicación',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '10',
    chapter_name: 'Protocolos de Comunicación para Cámaras de Video',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/N-EIP-2-01-010-14.pdf'
  },
  {
    name: 'N·EIP·2·01·012/15',
    type: 'Norma',
    book_id: 11,
    book_name: 'Características de los equipos y sistemas de instalación permanente',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Protocolos de Comunicación',
    title_id: '1',
    title_name: 'Sistemas Inteligentes de Transporte',
    chapter_id: '12',
    chapter_name: 'Protocolos de Comunicación para la Unidad Central de Procesamiento del Sistema de Pesaje Dinámico y Dimensionamiento Vehicular',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/N-EIP-2-01-012-15.pdf'
  },
  {
    name: 'M·MMP·1·01/03',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '1',
    title_name: 'Muestreo de Materiales para Terracerías',
    chapter_id: null,
    chapter_name: null,
    year: 2003,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-01-03.pdf'
  },
  {
    name: 'M·MMP·1·02/03',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '2',
    title_name: 'Clasificación de Fragmentos de Roca y Suelos',
    chapter_id: null,
    chapter_name: null,
    year: 2003,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-02-03.pdf'
  },
  {
    name: 'M·MMP·1·03/03',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '3',
    title_name: 'Secado, Disgregado y Cuarteo de Muestras',
    chapter_id: null,
    chapter_name: null,
    year: 2003,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-03-03.pdf'
  },
  {
    name: 'M·MMP·1·04/03',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '4',
    title_name: 'Contenido de Agua',
    chapter_id: null,
    chapter_name: null,
    year: 2003,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-04-03.pdf'
  },
  {
    name: 'M·MMP·1·05/18',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '5',
    title_name: 'Densidades Relativas y Absorción',
    chapter_id: null,
    chapter_name: null,
    year: 2018,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-05-18.pdf'
  },
  {
    name: 'M·MMP·1·05/03',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '5',
    title_name: 'Densidades Relativas y Absorción',
    chapter_id: null,
    chapter_name: null,
    year: 2003,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-05-03.pdf'
  },
  {
    name: 'M·MMP·1·06/03',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '6',
    title_name: 'Granulometría de Materiales Compactables para Terracerías',
    chapter_id: null,
    chapter_name: null,
    year: 2003,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-06-03.pdf'
  },
  {
    name: 'M·MMP·1·07/07',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '7',
    title_name: 'Límites de Consistencia',
    chapter_id: null,
    chapter_name: null,
    year: 2007,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-07-07.pdf'
  },
  {
    name: 'M·MMP·1·07/03',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '7',
    title_name: 'Límites de Consistencia',
    chapter_id: null,
    chapter_name: null,
    year: 2003,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-07-03.pdf'
  },
  {
    name: 'M·MMP·1·08/03',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '8',
    title_name: 'Masas Volumétricas y Coeficientes de Variación Volumétrica',
    chapter_id: null,
    chapter_name: null,
    year: 2003,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-08-03.pdf'
  },
  {
    name: 'M·MMP·1·09/06',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '9',
    title_name: 'Compactación AASHTO',
    chapter_id: null,
    chapter_name: null,
    year: 2006,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-09-06.pdf'
  },
  {
    name: 'M·MMP·1·09/03',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '9',
    title_name: 'Compactación AASHTO',
    chapter_id: null,
    chapter_name: null,
    year: 2003,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-09-03.pdf'
  },
  {
    name: 'M·MMP·1·10/19',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '10',
    title_name: 'Grado de Compactación',
    chapter_id: null,
    chapter_name: null,
    year: 2019,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-10-19.pdf'
  },
  {
    name: 'M·MMP·1·11/16',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '11',
    title_name: 'Valor Soporte de California (CBR) y Expansión (Exp) en Laboratorio',
    chapter_id: null,
    chapter_name: null,
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-11-16.pdf'
  },
  {
    name: 'M·MMP·1·11/13',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '11',
    title_name: 'Valor Soporte de California (CBR) y Expansión (Exp) en Laboratorio',
    chapter_id: null,
    chapter_name: null,
    year: 2013,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-11-13.pdf'
  },
  {
    name: 'M·MMP·1·11/08',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '11',
    title_name: 'Valor Soporte de California (CBR) y Expansión (Exp) en Laboratorio',
    chapter_id: null,
    chapter_name: null,
    year: 2008,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-11-08.pdf'
  },
  {
    name: 'M·MMP·1·12/13',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '12',
    title_name: 'Valor Soporte de California (CBR) en el Lugar',
    chapter_id: null,
    chapter_name: null,
    year: 2013,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-12-13.pdf'
  },
  {
    name: 'M·MMP·1·12/08',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 1,
    part_name: 'Suelos y Materiales para Terracerías',
    title_id: '12',
    title_name: 'Valor Soporte de California (CBR) en el Lugar',
    chapter_id: null,
    chapter_name: null,
    year: 2008,
    url: 'https://normas.imt.mx/normativa/M-MMP-1-12-08.pdf'
  },
  {
    name: 'M·MMP·2·02·001/00',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '1',
    chapter_name: 'Muestreo de Cemento Pórtland',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-001-00.pdf'
  },
  {
    name: 'M·MMP·2·02·002/00',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '2',
    chapter_name: 'Finura del Cemento por el Método del Tamiz',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-002-00.pdf'
  },
  {
    name: 'M·MMP·2·02·003/04',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '3',
    chapter_name: 'Finura del Cemento por el Método de Permeabilidad al Aire',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-003-04.pdf'
  },
  {
    name: 'M·MMP·2·02·004/04',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '4',
    chapter_name: 'Resistencia a la Compresión del Cemento Pórtland',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-004-04.pdf'
  },
  {
    name: 'M·MMP·2·02·006/04',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '6',
    chapter_name: 'Tiempo de Fraguado del Cemento por el Método de Vicat',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-006-04.pdf'
  },
  {
    name: 'M·MMP·2·02·020/18',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '20',
    chapter_name: 'Granulometría de los Agregados Pétreos',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-020-18.pdf'
  },
  {
    name: 'M·MMP·2·02·022/19',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '22',
    chapter_name: 'Coeficiente Volumétrico de los Agregados Pétreos Gruesos',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-022-19.pdf'
  },
  {
    name: 'M·MMP·2·02·023/18',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '23',
    chapter_name: 'Masa Volumétrica de los Agregados Pétreos',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-023-18.pdf'
  },
  {
    name: 'M·MMP·2·02·026/18',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '26',
    chapter_name: 'Impurezas Orgánicas en Agregados Finos',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-026-18.pdf'
  },
  {
    name: 'M·MMP·2·02·028/18',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '28',
    chapter_name: 'Sanidad de los Agregados mediante Sulfato de Sodio o de Magnesio',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-028-18.pdf'
  },
  {
    name: 'M·MMP·2·02·030/18',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '30',
    chapter_name: 'Partículas más Finas que la Malla N°200 (0,075 mm) en los Agregados',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-030-18.pdf'
  },
  {
    name: 'M·MMP·2·02·031/18',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '31',
    chapter_name: 'Terrones y Partículas Deleznables en los Agregados',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-031-18.pdf'
  },
  {
    name: 'M·MMP·2·02·032/18',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '32',
    chapter_name: 'Resistencia a la Degradación del Agregado Grueso mediante la Máquina de Los Ángeles',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-032-18.pdf'
  },
  {
    name: 'M·MMP·2·02·034/18',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '34',
    chapter_name: 'Reactividad Potencial de los Agregados mediante Barras de Mortero',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-034-18.pdf'
  },
  {
    name: 'M·MMP·2·02·036/18',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '36',
    chapter_name: 'Reactividad de los Agregados mediante el Método del Cilindro de Roca',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-036-18.pdf'
  },
  {
    name: 'M·MMP·2·02·038/18',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '38',
    chapter_name: 'Efectividad de Aditivos Minerales para Evitar una Expansión Excesiva del Concreto',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-038-18.pdf'
  },
  {
    name: 'M·MMP·2·02·055/06',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '55',
    chapter_name: 'Muestreo de Concreto Hidráulico',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-055-06.pdf'
  },
  {
    name: 'M·MMP·2·02·055/04',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '55',
    chapter_name: 'Muestreo de Concreto Hidráulico',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-055-04.pdf'
  },
  {
    name: 'M·MMP·2·02·056/06',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '56',
    chapter_name: 'Revenimiento del Concreto Fresco',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-056-06.pdf'
  },
  {
    name: 'M·MMP·2·02·056/04',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '56',
    chapter_name: 'Revenimiento del Concreto Fresco',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-056-04.pdf'
  },
  {
    name: 'M·MMP·2·02·058/04',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '58',
    chapter_name: 'Resistencia a la Compresión Simple de Cilindros de Concreto',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-058-04.pdf'
  },
  {
    name: 'M·MMP·2·02·059/04',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '59',
    chapter_name: 'Resistencia a la Tensión de Cilindros de Concreto',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-059-04.pdf'
  },
  {
    name: 'M·MMP·2·02·060/04',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '2',
    title_name: 'Materiales para Concreto Hidráulico',
    chapter_id: '60',
    chapter_name: 'Resistencia del Concreto a Congelación y Deshielo',
    year: 2004,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-02-060-04.pdf'
  },
  {
    name: 'M·MMP·2·07·001/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '7',
    title_name: 'Pinturas para Recubrimiento de Estructuras',
    chapter_id: '1',
    chapter_name: 'Muestreo de Pinturas para Recubrimiento de Estructuras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-07-001-01.pdf'
  },
  {
    name: 'M·MMP·2·07·002/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '7',
    title_name: 'Pinturas para Recubrimiento de Estructuras',
    chapter_id: '2',
    chapter_name: 'Finura Pinturas para Recubrimiento de Estructuras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-07-002-01.pdf'
  },
  {
    name: 'M·MMP·2·07·003/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '7',
    title_name: 'Pinturas para Recubrimiento de Estructuras',
    chapter_id: '3',
    chapter_name: 'Contenido de Pigmento en Pinturas para Recubrimiento de Estructuras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-07-003-01.pdf'
  },
  {
    name: 'M·MMP·2·07·004/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '7',
    title_name: 'Pinturas para Recubrimiento de Estructuras',
    chapter_id: '4',
    chapter_name: 'Sólidos Totales en Pinturas para Recubrimiento de Estructuras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-07-004-01.pdf'
  },
  {
    name: 'M·MMP·2·07·005/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '7',
    title_name: 'Pinturas para Recubrimiento de Estructuras',
    chapter_id: '5',
    chapter_name: 'Flexibilidad de Pinturas para Recubrimiento de Estructuras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-07-005-01.pdf'
  },
  {
    name: 'M·MMP·2·07·006/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '7',
    title_name: 'Pinturas para Recubrimiento de Estructuras',
    chapter_id: '6',
    chapter_name: 'Tiempo de Secado Duro de Pinturas para Recubrimiento de Estructuras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-07-006-01.pdf'
  },
  {
    name: 'M·MMP·2·07·007/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '7',
    title_name: 'Pinturas para Recubrimiento de Estructuras',
    chapter_id: '7',
    chapter_name: 'Viscosidad de Pinturas para Recubrimiento de Estructuras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-07-007-01.pdf'
  },
  {
    name: 'M·MMP·2·07·008/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '7',
    title_name: 'Pinturas para Recubrimiento de Estructuras',
    chapter_id: '8',
    chapter_name: 'Resistencia a los Rayos Ultravioleta de Pinturas para Recubrimiento de Estructuras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-07-008-01.pdf'
  },
  {
    name: 'M·MMP·2·07·009/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '7',
    title_name: 'Pinturas para Recubrimiento de Estructuras',
    chapter_id: '9',
    chapter_name: 'Resistencia al Ambiente Salino de Pinturas para Recubrimiento de Estructuras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-07-009-01.pdf'
  },
  {
    name: 'M·MMP·2·07·010/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 2,
    part_name: 'Materiales para Estructuras',
    title_id: '7',
    title_name: 'Pinturas para Recubrimiento de Estructuras',
    chapter_id: '10',
    chapter_name: 'Adherencia de Pinturas para Recubrimiento de Estructuras',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-2-07-010-01.pdf'
  },
  {
    name: 'M·MMP·4·02·001/18',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '2',
    title_name: 'Cal para Estabilizaciones',
    chapter_id: '1',
    chapter_name: 'Muestreo de Cal para Estabilizaciones',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-02-001-18.pdf'
  },
  {
    name: 'M·MMP·4·02·003/18',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '2',
    title_name: 'Cal para Estabilizaciones',
    chapter_id: '3',
    chapter_name: 'Características Granulométricas de la Cal',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-02-003-18.pdf'
  },
  {
    name: 'M·MMP·4·02·005/19',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '2',
    title_name: 'Cal para Estabilizaciones',
    chapter_id: '5',
    chapter_name: 'Contenido de Óxido de Calcio (CaO) y Óxido de Magnesio (MgO) en la Cal Viva',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-02-005-19.pdf'
  },
  {
    name: 'M·MMP·4·02·006/19',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '2',
    title_name: 'Cal para Estabilizaciones',
    chapter_id: '6',
    chapter_name: 'Contenido de Hidróxido de Calcio Ca(OH)2 en la Cal Hidratada',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-02-006-19.pdf'
  },
  {
    name: 'M·MMP·4·02·011/19',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '2',
    title_name: 'Cal para Estabilizaciones',
    chapter_id: '11',
    chapter_name: 'Determinación del Potencial de Hidrógeno (pH) en Materiales Tratados con Cal',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-02-011-19.pdf'
  },
  {
    name: 'M·MMP·4·02·012/19',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '2',
    title_name: 'Cal para Estabilizaciones',
    chapter_id: '12',
    chapter_name: 'Muestreo de Materiales Tratados con Cal',
    year: 2019,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-02-012-19.pdf'
  },
  {
    name: 'M·MMP·4·04·001/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: '1',
    chapter_name: 'Muestreo de Materiales Pétreos para Mezclas Asfálticas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-04-001-02.pdf'
  },
  {
    name: 'M·MMP·4·04·002/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: '2',
    chapter_name: 'Granulometría de Materiales Pétreos para Mezclas Asfálticas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-04-002-02.pdf'
  },
  {
    name: 'M·MMP·4·04·003/18',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: '3',
    chapter_name: 'Densidades Relativas y Absorción de Materiales Pétreos para Mezclas Asfálticas',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-04-003-18.pdf'
  },
  {
    name: 'M·MMP·4·04·003/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: '3',
    chapter_name: 'Densidad Relativa de Materiales Pétreos para Mezclas Asfálticas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-04-003-02.pdf'
  },
  {
    name: 'M·MMP·4·04·004/16',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: '4',
    chapter_name: 'Equivalente de Arena de Materiales Pétreos para Mezclas Asfálticas',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-04-004-16.pdf'
  },
  {
    name: 'M·MMP·4·04·004/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: '4',
    chapter_name: 'Equivalente de Arena de Materiales Pétreos para Mezclas Asfálticas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-04-004-02.pdf'
  },
  {
    name: 'M·MMP·4·04·005/08',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: '5',
    chapter_name: 'Partículas Alargadas y Lajeadas de Materiales Pétreos para Mezclas Asfálticas',
    year: 2008,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-04-005-08.pdf'
  },
  {
    name: 'M·MMP·4·04·005/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: '5',
    chapter_name: 'Partículas Alargadas y Lajeadas de Materiales Pétreos para Mezclas Asfálticas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-04-005-02.pdf'
  },
  {
    name: 'M·MMP·4·04·006/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: '6',
    chapter_name: 'Desgaste Mediante la Prueba de Los Ángeles de Materiales Pétreos para Mezclas Asfálticas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-04-006-02.pdf'
  },
  {
    name: 'M·MMP·4·04·008/03',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: '8',
    chapter_name: 'Interperismo Acelerado de Materiales Pétreos para Mezclas Asfálticas',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-04-008-03.pdf'
  },
  {
    name: 'M·MMP·4·04·009/03',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: '9',
    chapter_name: 'Desprendimiento por Fricción en Materiales Pétreos para Mezclas Asfálticas',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-04-009-03.pdf'
  },
  {
    name: 'M·MMP·4·04·010/03',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: '10',
    chapter_name: 'Cubrimiento con Asfalto mediante el Método Inglés de Materiales Pétreos para Mezclas Asfálticas',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-04-010-03.pdf'
  },
  {
    name: 'M·MMP·4·04·013/09',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: '13',
    chapter_name: 'Partículas Trituradas de Materiales Pétreos para Mezclas Asfálticas',
    year: 2009,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-04-013-09.pdf'
  },
  {
    name: 'M·MMP·4·04·014/09',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: '14',
    chapter_name: 'Azul de Metileno de Materiales Pétreos para Mezclas Asfálticas',
    year: 2009,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-04-014-09.pdf'
  },
  {
    name: 'M·MMP·4·04·015/15',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '4',
    title_name: 'Materiales Pétreos para Mezclas Asfálticas',
    chapter_id: '15',
    chapter_name: 'Densidad Relativa Aparente por Inmersión en Cemento Asfáltico de Materiales Pétreos para Mezclas Asfálticas',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-04-015-15.pdf'
  },
  {
    name: 'M·MMP·4·05·001/00',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '1',
    chapter_name: 'Muestreo de Materiales Asfálticos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-001-00.pdf'
  },
  {
    name: 'M·MMP·4·05·002/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '2',
    chapter_name: 'Viscosidad Dinámica de Cementos y Residuos Asfálticos',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-002-02.pdf'
  },
  {
    name: 'M·MMP·4·05·003/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '3',
    chapter_name: 'Viscosidad Cinemática de Cementos Asfálticos',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-003-02.pdf'
  },
  {
    name: 'M·MMP·4·05·004/00',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '4',
    chapter_name: 'Viscosidad Saybolt-Furol en Materiales Asfálticos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-004-00.pdf'
  },
  {
    name: 'M·MMP·4·05·005/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '5',
    chapter_name: 'Viscosidad Rotacional Brookfield de Cementos Asfálticos',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-005-02.pdf'
  },
  {
    name: 'M·MMP·4·05·006/00',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '6',
    chapter_name: 'Penetración en Cementos y Residuos Asfálticos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-006-00.pdf'
  },
  {
    name: 'M·MMP·4·05·007/00',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '7',
    chapter_name: 'Punto de Inflamación Cleveland en Cementos Asfálticos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-007-00.pdf'
  },
  {
    name: 'M·MMP·4·05·008/00',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '8',
    chapter_name: 'Solubilidad de Cementos y Residuos Asfálticos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-008-00.pdf'
  },
  {
    name: 'M·MMP·4·05·009/00',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '9',
    chapter_name: 'Punto de Reblandecimiento en Cementos Asfálticos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-009-00.pdf'
  },
  {
    name: 'M·MMP·4·05·010/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '10',
    chapter_name: 'Pruebas en el Residuo de la Película Delgada de Cementos Asfálticos',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-010-02.pdf'
  },
  {
    name: 'M·MMP·4·05·011/07',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '11',
    chapter_name: 'Ductilidad de Cementos y Residuos Asfálticos',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-011-07.pdf'
  },
  {
    name: 'M·MMP·4·05·011/00',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '11',
    chapter_name: 'Ductilidad de Cementos y Residuos Asfálticos',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-011-00.pdf'
  },
  {
    name: 'M·MMP·4·05·012/00',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '12',
    chapter_name: 'Destilación de Emulsiones Asfálticas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-012-00.pdf'
  },
  {
    name: 'M·MMP·4·05·013/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '13',
    chapter_name: 'Asentamiento de Emulsiones Asfálticas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-013-02.pdf'
  },
  {
    name: 'M·MMP·4·05·014/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '14',
    chapter_name: 'Retenido en las Mallas N°20 y N°60 en Emulsiones Asfálticas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-014-02.pdf'
  },
  {
    name: 'M·MMP·4·05·015/00',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '15',
    chapter_name: 'Cubrimiento del Agregado en Emulsiones Asfálticas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-015-00.pdf'
  },
  {
    name: 'M·MMP·4·05·016/00',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '16',
    chapter_name: 'Miscibilidad con Cemento Pórtland de Emulsiones Asfálticas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-016-00.pdf'
  },
  {
    name: 'M·MMP·4·05·017/00',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '17',
    chapter_name: 'Carga Eléctrica de las Partículas de Emulsiones Asfálticas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-017-00.pdf'
  },
  {
    name: 'M·MMP·4·05·018/07',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '18',
    chapter_name: 'Demulsibilidad de Emulsiones Asfálticas',
    year: 2007,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-018-07.pdf'
  },
  {
    name: 'M·MMP·4·05·018/00',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '18',
    chapter_name: 'Demulsibilidad de Emulsiones Asfálticas',
    year: 2000,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-018-00.pdf'
  },
  {
    name: 'M·MMP·4·05·019/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '19',
    chapter_name: 'Índice de Ruptura de Emulsiones Asfálticas Catiónicas',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-019-02.pdf'
  },
  {
    name: 'M·MMP·4·05·020/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '20',
    chapter_name: 'Punto de Inflamación Tag en Asfaltos Rebajados',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-020-02.pdf'
  },
  {
    name: 'M·MMP·4·05·021/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '21',
    chapter_name: 'Destilación de Asfaltos Rebajados',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-021-02.pdf'
  },
  {
    name: 'M·MMP·4·05·022/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '22',
    chapter_name: 'Separación en Cemento Asfáltico Modificado',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-022-02.pdf'
  },
  {
    name: 'M·MMP·4·05·023/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '23',
    chapter_name: 'Resiliencia en Cemento Asfáltico Modificado',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-023-02.pdf'
  },
  {
    name: 'M·MMP·4·05·024/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '24',
    chapter_name: 'Recuperación Elástica por Torsión en Cemento Asfáltico Modificado',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-024-02.pdf'
  },
  {
    name: 'M·MMP·4·05·025/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '25',
    chapter_name: 'Módulo Reológico de Corte Dinámico',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-025-02.pdf'
  },
  {
    name: 'M·MMP·4·05·026/02',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '26',
    chapter_name: 'Recuperación Elástica en Ductilómetro',
    year: 2002,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-026-02.pdf'
  },
  {
    name: 'M·MMP·4·05·039/15',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '39',
    chapter_name: 'Contenido de Agua en Mezclas Asfálticas',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-039-15.pdf'
  },
  {
    name: 'M·MMP·4·05·040/15',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '40',
    chapter_name: 'Contenido de Disolventes en Mezclas Asfálticas',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-040-15.pdf'
  },
  {
    name: 'M·MMP·4·05·041/03',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '41',
    chapter_name: 'Desgaste por Abrasión en Húmedo de Morteros Asfálticos',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-041-03.pdf'
  },
  {
    name: 'M·MMP·4·05·042/03',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '42',
    chapter_name: 'Pérdida de Estabilidad por Inmersión en Agua de Mezclas Asfálticas',
    year: 2003,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-042-03.pdf'
  },
  {
    name: 'M·MMP·4·05·047/15',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '47',
    chapter_name: 'Contenido de Cemento o Residuo Asfáltico en Mezclas Asfálticas por el Método Colorimétrico',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-047-15.pdf'
  },
  {
    name: 'M·MMP·4·05·048/15',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '48',
    chapter_name: 'Contenido de Cemento o Residuo Asfáltico en Mezclas Asfálticas mediante la Recirculación de Disolventes en Caliente',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-048-15.pdf'
  },
  {
    name: 'M·MMP·4·05·049/15',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '49',
    chapter_name: 'Contenido de Cemento o Residuo Asfáltico en Mezclas Asfálticas mediante Extracción por Centrifugado',
    year: 2015,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-049-15.pdf'
  },
  {
    name: 'M·MMP·4·05·055/17',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '5',
    title_name: 'Materiales Asfálticos, Aditivos y Mezclas',
    chapter_id: '55',
    chapter_name: 'Prueba de Esfuerzo-Deformación-Recuperación Múltiple (MSCR)',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-05-055-17.pdf'
  },
  {
    name: 'M·MMP·4·07·002/06',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '2',
    chapter_name: 'Índice de Perfil',
    year: 2006,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-002-06.pdf'
  },
  {
    name: 'M·MMP·4·07·003/16',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '3',
    chapter_name: 'Determinación del Perfil Longitudinal con Equipo Escáner Transversal',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-003-16.pdf'
  },
  {
    name: 'M·MMP·4·07·004/16',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '4',
    chapter_name: 'Determinación del Perfil Longitudinal con Perfilómetro Inercial',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-004-16.pdf'
  },
  {
    name: 'M·MMP·4·07·005/16',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '5',
    chapter_name: 'Determinación del Perfil Longitudinal con Equipo de Tipo Respuesta',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-005-16.pdf'
  },
  {
    name: 'M·MMP·4·07·006/16',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '6',
    chapter_name: 'Determinación del Perfil Longitudinal con Nivel y Estadal para el Cálculo de Índice de Regularidad Internacional',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-006-16.pdf'
  },
  {
    name: 'M·MMP·4·07·007/16',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '7',
    chapter_name: 'Determinación de la Macrotextura con Equipo Escáner',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-007-16.pdf'
  },
  {
    name: 'M·MMP·4·07·008/16',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '8',
    chapter_name: 'Determinación de la Profundidad Media de la Macrotextura con Perfilómetro Láser',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-008-16.pdf'
  },
  {
    name: 'M·MMP·4·07·009/16',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '9',
    chapter_name: 'Determinación de la Profundidad Media de la Macrotextura de un Pavimento por el Método del Círculo de Arena',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-009-16.pdf'
  },
  {
    name: 'M·MMP·4·07·010/17',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '10',
    chapter_name: 'Determinación del Coeficiente de Fricción con Equipo de Rueda Oblicua',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-010-17.pdf'
  },
  {
    name: 'M·MMP·4·07·011/17',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '11',
    chapter_name: 'Determinación del Coeficiente de Fricción con Equipo de Rueda Parcialmente Bloqueada',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-011-17.pdf'
  },
  {
    name: 'M·MMP·4·07·012/17',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '12',
    chapter_name: 'Determinación del Coeficiente de Fricción con Equipo de Rueda Bloqueada',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-012-17.pdf'
  },
  {
    name: 'M·MMP·4·07·013/17',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '13',
    chapter_name: 'Determinación del Coeficiente de Fricción con Péndulo Británico',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-013-17.pdf'
  },
  {
    name: 'M·MMP·4·07·014/17',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '14',
    chapter_name: 'Determinación de los Deterioros Superficiales del Pavimento con Equipo Escáner',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-014-17.pdf'
  },
  {
    name: 'M·MMP·4·07·015/17',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '15',
    chapter_name: 'Determinación de Deterioros Superficiales del Pavimento con Equipo Láser',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-015-17.pdf'
  },
  {
    name: 'M·MMP·4·07·016/17',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '16',
    chapter_name: 'Determinación de los Deterioros Superficiales de Pavimento por Inspección Visual',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-016-17.pdf'
  },
  {
    name: 'M·MMP·4·07·017/16',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '17',
    chapter_name: 'Determinación del Perfil Transversal y Cálculo de la Profundidad de Roderas con Perfilómetro de Alto Rendimiento',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-017-16.pdf'
  },
  {
    name: 'M·MMP·4·07·018/16',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '18',
    chapter_name: 'Determinación de la Profundidad de Rodera con Equipo Óptico Láser',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-018-16.pdf'
  },
  {
    name: 'M·MMP·4·07·019/16',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '19',
    chapter_name: 'Determinación de la Profundidad de Rodera con Equipo de Bajo Rendimiento',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-019-16.pdf'
  },
  {
    name: 'M·MMP·4·07·020/17',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '20',
    chapter_name: 'Determinación de las Deflexiones con Equipo de Impacto',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-020-17.pdf'
  },
  {
    name: 'M·MMP·4·07·021/17',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '21',
    chapter_name: 'Determinación de las Deflexiones con Equipo de Medición Estática',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-021-17.pdf'
  },
  {
    name: 'M·MMP·4·07·022/17',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '22',
    chapter_name: 'Determinación de las Deflexiones con Equipo de Medición Dinámica',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-022-17.pdf'
  },
  {
    name: 'M·MMP·4·07·023/18',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 4,
    part_name: 'Materiales para pavimentos',
    title_id: '7',
    title_name: 'Superficie de Rodadura',
    chapter_id: '23',
    chapter_name: 'Determinación del Índice de Fricción Internacional y del Diagrama Macrotextura-Fricción',
    year: 2018,
    url: 'https://normas.imt.mx/normativa/M-MMP-4-07-023-18.pdf'
  },
  {
    name: 'M·MMP·5·01·001/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '1',
    title_name: 'Pinturas para Señalamiento',
    chapter_id: '1',
    chapter_name: 'Muestreo de Pinturas para Señalamiento Horizontal',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-01-001-01.pdf'
  },
  {
    name: 'M·MMP·5·01·002/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '1',
    title_name: 'Pinturas para Señalamiento',
    chapter_id: '2',
    chapter_name: 'Finura Pinturas para Señalamiento Horizontal',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-01-002-01.pdf'
  },
  {
    name: 'M·MMP·5·01·003/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '1',
    title_name: 'Pinturas para Señalamiento',
    chapter_id: '3',
    chapter_name: 'Contenido de Pigmentos en Pinturas para Señalamiento Horizontal',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-01-003-01.pdf'
  },
  {
    name: 'M·MMP·5·01·004/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '1',
    title_name: 'Pinturas para Señalamiento',
    chapter_id: '4',
    chapter_name: 'Sólidos Totales en Pinturas para Señalamiento Horizontal',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-01-004-01.pdf'
  },
  {
    name: 'M·MMP·5·01·005/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '1',
    title_name: 'Pinturas para Señalamiento',
    chapter_id: '5',
    chapter_name: 'Flexibilidad de Pinturas para Señalamiento Horizontal',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-01-005-01.pdf'
  },
  {
    name: 'M·MMP·5·01·020/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '1',
    title_name: 'Pinturas para Señalamiento',
    chapter_id: '20',
    chapter_name: 'Muestreo de Pinturas para Señalamiento Vertical',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-01-020-01.pdf'
  },
  {
    name: 'M·MMP·5·01·021/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '1',
    title_name: 'Pinturas para Señalamiento',
    chapter_id: '21',
    chapter_name: 'Finura de Pinturas para Señalamiento Vertical',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-01-021-01.pdf'
  },
  {
    name: 'M·MMP·5·01·022/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '1',
    title_name: 'Pinturas para Señalamiento',
    chapter_id: '22',
    chapter_name: 'Contenido de Pigmentos en Pinturas para Señalamiento Vertical',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-01-022-01.pdf'
  },
  {
    name: 'M·MMP·5·01·023/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '1',
    title_name: 'Pinturas para Señalamiento',
    chapter_id: '23',
    chapter_name: 'Sólidos Totales en Pinturas para Señalamiento Vertical',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-01-023-01.pdf'
  },
  {
    name: 'M·MMP·5·01·024/01',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '1',
    title_name: 'Pinturas para Señalamiento',
    chapter_id: '24',
    chapter_name: 'Flexibilidad en Pinturas para Señalamiento Vertical',
    year: 2001,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-01-024-01.pdf'
  },
  {
    name: 'M·MMP·5·04·001/14',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '4',
    title_name: 'Botones y Botones Reflejantes',
    chapter_id: '1',
    chapter_name: 'Muestreo de Botones y Botones Reflejantes',
    year: 2014,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-04-001-14.pdf'
  },
  {
    name: 'M·MMP·5·04·002/12',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '4',
    title_name: 'Botones y Botones Reflejantes',
    chapter_id: '2',
    chapter_name: 'Reflexión de Botones Reflejantes y Delimitadores',
    year: 2012,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-04-002-12.pdf'
  },
  {
    name: 'M·MMP·5·04·003/12',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '4',
    title_name: 'Botones y Botones Reflejantes',
    chapter_id: '3',
    chapter_name: 'Colorimetría de Botones Reflejantes y Delimitadores',
    year: 2012,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-04-003-12.pdf'
  },
  {
    name: 'M·MMP·5·04·004/12',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '4',
    title_name: 'Botones y Botones Reflejantes',
    chapter_id: '4',
    chapter_name: 'Resistencia a la Abrasión de Botones Reflejantes y Delimitadores sobre el Pavimento',
    year: 2012,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-04-004-12.pdf'
  },
  {
    name: 'M·MMP·5·04·005/12',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '4',
    title_name: 'Botones y Botones Reflejantes',
    chapter_id: '5',
    chapter_name: 'Resistencia a la Compresión Simple de Botones y Botones Reflejantes sobre el Pavimento',
    year: 2012,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-04-005-12.pdf'
  },
  {
    name: 'M·MMP·5·04·006/12',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '4',
    title_name: 'Botones y Botones Reflejantes',
    chapter_id: '6',
    chapter_name: 'Resistencia a la Flexión de Botones Reflejantes sobre el Pavimento',
    year: 2012,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-04-006-12.pdf'
  },
  {
    name: 'M·MMP·5·04·007/12',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '4',
    title_name: 'Botones y Botones Reflejantes',
    chapter_id: '7',
    chapter_name: 'Resistencia al Agrietamiento del Elemento Reflejante de Botones Reflejantes y Delimitadores sobre el Pavimento',
    year: 2012,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-04-007-12.pdf'
  },
  {
    name: 'M·MMP·5·04·008/12',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 5,
    part_name: 'Materiales para Señalamiento y Dispositivos de Seguridad',
    title_id: '4',
    title_name: 'Botones y Botones Reflejantes',
    chapter_id: '8',
    chapter_name: 'Resistencia a la Tensión de Adhesivos para Botones y Botones Reflejantes sobre el Pavimento',
    year: 2012,
    url: 'https://normas.imt.mx/normativa/M-MMP-5-04-008-12.pdf'
  },
  {
    name: 'M·MMP·6·01·001/16',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 6,
    part_name: 'Materiales Diversos',
    title_id: '1',
    title_name: 'Geosintéticos',
    chapter_id: '1',
    chapter_name: 'Muestreo de Geosintéticos',
    year: 2016,
    url: 'https://normas.imt.mx/normativa/M-MMP-6-01-001-16.pdf'
  },
  {
    name: 'M·MMP·6·01·004/17',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 6,
    part_name: 'Materiales Diversos',
    title_id: '1',
    title_name: 'Geosintéticos',
    chapter_id: '4',
    chapter_name: 'Resistencia a la Tensión Grab y Elongación de Geotextiles',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/M-MMP-6-01-004-17.pdf'
  },
  {
    name: 'M·MMP·6·01·005/17',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 6,
    part_name: 'Materiales Diversos',
    title_id: '1',
    title_name: 'Geosintéticos',
    chapter_id: '5',
    chapter_name: 'Resistencia al Rasgado de Geotextiles',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/M-MMP-6-01-005-17.pdf'
  },
  {
    name: 'M·MMP·6·01·019/17',
    type: 'Manual',
    book_id: 12,
    book_name: 'Métodos de Muestreo y Prueba de Materiales',
    theme_id: null,
    theme_name: null,
    part_id: 6,
    part_name: 'Materiales Diversos',
    title_id: '1',
    title_name: 'Geosintéticos',
    chapter_id: '19',
    chapter_name: 'Rígidez a la Flexión de Geomallas',
    year: 2017,
    url: 'https://normas.imt.mx/normativa/M-MMP-6-01-019-17.pdf'
  }
]
